import { Component, OnInit, OnDestroy } from '@angular/core'

import { HttpClient } from '@angular/common/http'
import { environment } from '.../../environments/environment'
import { MomentDateAdapter } from '@angular/material-moment-adapter'
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core'

import { Observable, Subscription } from 'rxjs/Rx'
import { ActivatedRoute, Router } from '@angular/router'
import { AuthService } from '../../_services/index'
import { utils, write, WorkBook } from 'xlsx'
import { saveAs } from 'file-saver'
import { Broadcaster } from '.../../environments/broadcaster'
import { LoaderService } from '../../_services/loader.service'
import Swal from 'sweetalert2'

import * as _moment from 'moment'
import * as _rollupMoment from 'moment'
import * as _ from 'lodash'

const moment = _rollupMoment || _moment
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
declare var $: any
declare var google: any
declare var firebase: any
declare var MapLabel: any
var stopAnimation = true

declare const MarkerClusterer

@Component({
  selector: 'vehicles-cmp',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class VehiclesComponent implements OnInit, OnDestroy {
  standBy: any
  public polyline_array
  routeAccuracy: any
  multiRoute: any
  assignWard: any
  tripData: any
  beatName: any
  clickedEntity: any
  clickedMarker: any
  IEMI: any
  VEHNO: any
  notInDb: any
  totalNotInDb = 0
  tempVehiclesData: any
  mapLabelArray: any
  public drivingSummary: any
  public projectID: any
  public project: any
  public map: any
  public projectMaster: any
  public vehiclesData: any
  public selectedlist: number
  public vehiclesLocation: any
  public vehiclesRoute: any
  public search: any
  public selectedProjectId: any
  public PRJNAME: any
  public polygondData: any
  public prjID: any
  public date = moment()
  public dateChanege = moment()
  public latlongs = []
  countData: any
  all: any
  inactive: any
  notmoving: any
  active: any
  live: any
  offline: any
  old: any
  mismatch = 0
  notInDbAndLiveArray = []
  notInDbAndOfflineArray = []
  deadAndLive: any
  notInDbAndLive = 0
  notInDbAndOffline = 0
  dead: any
  routePath: any
  inactiveArray = []
  activeArray = []
  liveArray = []
  offlineArray = []
  oldArray = []
  mismatchArray = []
  notmovingArray = []
  deadArray = []
  dataWithoutDead = []
  activeAndLive = []
  vehiclesDataTemp: any
  isLive: any
  a = []
  route: any
  markerStart: any
  markerEnd: any
  currentVehiclesData: any
  vehiclesNo: any
  IMEI: any
  vehiclesType: any
  mobileNo: any
  startTime: any
  endTime: any
  geocoder: any
  currentAddress: any
  Liveroute: any
  distance: any
  stopAnimation: any
  allMarkers = []
  autoTicks = false
  disabled = false
  invert = false
  max = 1000
  public value: any
  min = 0
  showTicks = false
  step = 1
  thumbLabel = false
  position = [43, -89]
  vertical = false
  counter: any
  public icon: any
  totalStop: any
  totalDuration: any
  vechicleListIsClicked: any
  servingWardName: any
  servingBeat: any
  stopSummary: any
  totalStopBeat: any
  wardBoundary: any
  beatBoundary: any
  routeBoundary
  polygon: any
  infoWindowStart: any
  infoWindowEnd: any
  controlText: any
  centerControlDiv: any
  vehicleCluster: any
  markerCluster: any
  deadVehicleSummary: any
  notRunningSince15Days: any
  notRunningSince10Days: any
  notRunningSince5Days: any
  notRunningSince2Days: any
  notRunningSince15DaysArray: any
  notRunningSince10DaysArray: any
  notRunningSince5DaysArray: any
  notRunningSince2DaysArray: any
  deadVehicleList: any
  selectedDeadList: any
  searchDeadList: any
  runningVehiclesByType: any
  isStats: any
  totalWorking: any
  totalAvilable: any
  showLoader: any
  isClickedVehicle: any
  vehicleInfoWindow: any
  vehicleInfoWindowClicked: any
  plotSecondary: any

  plotKhattaPoint: any
  plotClosedKhattaPoint: any
  plotParking: any
  plotFCTS: any
  plotPCTS: any
  plotMTS: any
  plotBins: any

  secondaryPointData: any
  secPointMarker: any
  wardPolygonList: any
  vehicleInWard: any
  lastActiveTime: any
  fuelTypeCount: any
  maintenanceStatusCount: any
  maintenanceStatusVtsCount: any
  currentAddressStart: any
  filterData: any = {}
  ownerList: any
  vehicleCategoryList: any
  fuelTypeList: any
  areaAssignment: any
  staffAssignment: any
  routeAssignment: any
  VEHID: any
  zoneWardInfoWindow: any
  authtoken: any
  zonesList: any
  isLko: boolean = false
  plotPlant: any
  zonesListing: any
  zonesData: any

  liveStandBy: any
  DNRStandBy: any
  liveMaint: any
  DNRMaint: any
  totalRunning: number
  selectedLineDetails: any

  private subscription: Subscription
  isUnderMaintenance: boolean = false
  isAssignment: boolean = false
  isCustomLoading: boolean = false
  wardsList: any
  isZoneSelected: boolean = false
  zoneID: any
  isWardSelected: boolean = false
  preDate: boolean = false
  wardID: any
  wardPolygondData: any
  beatPolygondData: any
  routePolygondData: any
  wardName: any
  stopBtn: boolean = false
  isVehicleClicked: boolean
  totalKHATTA: any
  totalFCTS: any
  totalPARKING: any
  totalBINS: any
  totalPLANT: any
  totalMTS: any
  totalPCTS: any
  totalCLOSED: number
  vehcileReport: any
  currentDate: boolean
  fuelType: any
  ownerType: any
  vehCat: any
  test: 'Test'
  beatList: any
  totalFixedNumberVehs: any
  FixedNum: any
  alarmList: any
  singleVehAlarmPoints: any
  newRouteData: Object
  NewKM: any
  cover: any
  litterBinsData: any
  userId: string
  FourTime: boolean
  current_time: any
  contractorList: any
  ownerNameSearch: any
  selectedContractorName: any
  McgDisplayNumber: any
  downloadReportDate: any
  isLiveEnable: boolean
  disabeDownloadBtn: boolean
  selectedDatenew = moment().format('YYYY-MM-DD')

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private loaderService: LoaderService,
    private routes: ActivatedRoute,
    private broadcaster: Broadcaster,
    private router: Router,
  ) {
    this.authtoken = JSON.parse(localStorage.getItem('authData'))
    this.routeAccuracy = false
    this.vehicleInfoWindow = new google.maps.InfoWindow()
    this.vehicleInfoWindowClicked = new google.maps.InfoWindow()
    this.value = 300
    this.multiRoute = []
    this.polyline_array = []
    this.secPointMarker = []
    this.vehicleInWard = []
    this.mapLabelArray = []
    this.plotSecondary = false
    this.fuelTypeCount = null
    this.isStats = true
    this.disabeDownloadBtn = false
    this.isLiveEnable = false
    this.runningVehiclesByType = []
    this.McgDisplayNumber = 310
    //this.vehicleCluster  = true
    this.prjID = this.auth.getAuthentication().projectId
    var car =
      'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
    this.icon = {
      path: car,
      scale: 0.5,
      strokeColor: 'white',
      strokeWeight: 0.1,
      fillOpacity: 1,
      fillColor: '#404040',
      offset: '3%',
      // rotation: parseInt(heading[i]),
      anchor: new google.maps.Point(10, 25), // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
    }

    this.controlText = document.createElement('div')
    this.centerControlDiv = document.createElement('div')
    this.centerControlDiv.index = 1
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val
    })

    this.countData = {
      RUNNING: 0,
      NOT_STARTED: 0,
      STOPPED: 0,
      TOTAL: 0,
      LIVE: 0,
      OFFLINE: 0,
      TOTALRUNNING: 0,
      DATA_NOT_RECEIVED: 0,
      VTSINSTALLED: 0,
      VTSNOTINSTALLED: 0,
      MAINTENANCE: 0,
      STANDBY: 0,
    }

    this.selectedContractorName = ''

    this.FixedNum = 0

    this.http
      .get(environment.apiUrl + 'entity/getAllWardPolygons?prjid=' + this.prjID)
      .subscribe((data) => {
        var result: any
        result = data
        this.wardPolygondData = result
      })
    this.http
      .get(environment.apiUrl + 'entity/getAllBeatPolygons?prjid=' + this.prjID)
      .subscribe((data) => {
        var result: any
        result = data
        this.beatPolygondData = result
      })
    this.http
      .get(
        environment.apiUrl +
          'entity/getAllRoutePolygons?prjid=' +
          this.prjID +
          '&wardid=',
      )
      .subscribe((data) => {
        var result: any
        result = data
        this.routePolygondData = result
      })
  }

  // mergeVechiclesData() {
  //     for (var i = 0; i < this.vehiclesData.length; i++) {
  //         if (this.vehiclesData[i].FUELTYPE == 'Diesel') {
  //             this.fuelTypeCount.total.diesel++;
  //             if (this.vehiclesData[i].MAINTID == 3 || this.vehiclesData[i].MAINTID == 2) {
  //                 this.maintenanceStatusCount.ms.diesel++;
  //             } else if (this.vehiclesData[i].MAINTID == 4) {
  //                 this.maintenanceStatusCount.standBy.diesel++;
  //             }
  //         } else if (this.vehiclesData[i].FUELTYPE == 'Electric') {
  //             this.fuelTypeCount.total.electric++;
  //             if (this.vehiclesData[i].MAINTID == 3 || this.vehiclesData[i].MAINTID == 2) {
  //                 this.maintenanceStatusCount.ms.electric++;
  //             } else if (this.vehiclesData[i].MAINTID == 4) {
  //                 this.maintenanceStatusCount.standBy.electric++;
  //             }
  //         } else if (this.vehiclesData[i].FUELTYPE == 'Manual') {
  //             this.fuelTypeCount.total.manual++;
  //             if (this.vehiclesData[i].MAINTID == 3 || this.vehiclesData[i].MAINTID == 2) {
  //                 this.maintenanceStatusCount.ms.manual++;
  //             } else if (this.vehiclesData[i].MAINTID == 4) {
  //                 this.maintenanceStatusCount.standBy.manual++;
  //             }
  //         }

  //         for (var j = 0; j < this.vehiclesLocation.length; j++) {
  //             if (this.vehiclesData[i].IMEI == this.vehiclesLocation[j].DEVICEID) {
  //                 this.vehiclesLocation[j].VEHNO = this.vehiclesData[i].vehno;
  //                 var d = this.vehiclesLocation[j].LASTACTIVE;
  //                 this.vehiclesLocation[j].LASTACTIVEDATE = moment(new Date(d)).format('LTS');
  //                 this.vehiclesLocation[j].FUELTYPE = this.vehiclesData[i].FUELTYPE;
  //                 this.vehiclesLocation[j].MAINTID = this.vehiclesData[i].MAINTID;
  //             }
  //         }
  //     }
  // }

  getAllSecondaryVehiclesOwnerNames() {
    this.http
      .get(
        environment.apiUrl +
          'entity/getAllSecondaryVehiclesOwnerNames?prjid=' +
          this.prjID,
      )
      .subscribe((data) => {
        var result: any
        result = data
        // this.contractorList = result;

        var newResult = []

        for (let index = 0; index < result.length; index++) {
          newResult.push({ ID: index + 1, OWNERNAME: result[index].OWNERNAME })
        }

        this.contractorList = newResult

        //console.log(this.contractorList);
      })
  }

  selectedContractorSelectOnchange(e) {
    this.selectedContractorName = e.target.value
  }

  getDataWhenProjectChange = async (id) => {
    $('#loderImgTab').show()
    this.loaderService.display(true)
    this.renoveAllMarker()
    let polygon = await fetch(
      environment.apiUrl +
        'entity/getPolygonByOemId' +
        '?prjid=' +
        id +
        '&wardOemId=null' +
        '&beatOemId=null',
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.polygondData = await polygon.json()

    this.zonesData = this.polygondData.entityData
    // this.zonesListing = this.zonesData.entityname

    this.ownerList = [
      { ID: 1, name: 'Ecogreen' },
      { ID: 2, name: 'Contractor' },
    ]

    let zones = await fetch(
      environment.apiUrl + 'entity/getZonesByOEMIDandPrjid?prjid=' + this.prjID,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.zonesList = await zones.json()
    var nullObj = {
      ID: '11111',
      entityName: null,
      displayName: 'N/A',
      name: null,
    }
    var fbdZones = [
      {
        ID: '22222',
        displayName: 'ZONE-1',
        entityName: 'FBD-ZONE1',
        name: 'ZONE-1',
      },
      {
        ID: '33333',
        displayName: 'ZONE-2',
        entityName: 'FBD-ZONE2',
        name: 'ZONE-2',
      },
      {
        ID: '44444',
        displayName: 'ZONE-4',
        entityName: 'FBD-ZONE4',
        name: 'ZONE-4',
      },
    ]
    this.zonesList.push(nullObj)
    if (this.prjID == 3) {
      this.zonesList = this.zonesList.concat(fbdZones)
    }

    this.vehicleCategoryList = [
      { ID: 1, name: 'Primary' },
      { ID: 2, name: 'Secondary' },
      { ID: 3, name: 'Plant Vehicle' },
    ]
    this.fuelTypeList = [
      { ID: 1, name: 'Diesel' },
      { ID: 2, name: 'Electric' },
      { ID: 3, name: 'Manual' },
      { ID: 4, name: 'CNG' },
    ]

    // this.contractorList = [{ ID: 1, SWMCheckInOWNERNAME: 'SANTPAL' }, { ID: 2, OWNERNAME: 'Radhe Radhe' }]

    // //console.log("this.fuelTypeList",typeof(this.fuelTypeList));
    // //console.log("this.fuelTypeList",this.fuelTypeList);

    this.filterData = {
      ownerType: [
        { ID: 1, name: 'Ecogreen' },
        { ID: 2, name: 'Contractor' },
      ],
      vehicleCat: [{ ID: 1, name: 'Primary' }],
      zonesLi: this.zonesList,
      fuelType: [
        { ID: 1, name: 'Diesel' },
        { ID: 4, name: 'CNG' },
      ],
      ownerName: [],
    }

    this.clearFeature()
    this.map.data.addGeoJson(this.polygondData.geoJson)
    this.zoom(this.map, true)
    this.setStyle(this)

    let d = await fetch(
      environment.apiUrl +
        'vehicles/getAll?currentUserID=' +
        this.userId +
        '&prjId=' +
        this.prjID +
        '&date=' +
        moment().format('YYYY-MM-DD'),
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.tempVehiclesData = await d.json()

    this.vehiclesData = this.tempVehiclesData.liveData

    // //console.log("this.contractorList",typeof(this.contractorList));
    // //console.log("this.contractorList",this.contractorList);

    this.notInDb = this.tempVehiclesData.notInDb
    this.totalNotInDb = this.tempVehiclesData.notInDb.length

    this.applyFilter(this.tempVehiclesData.liveData)
    this.getCount(this.vehiclesData)
    this.plotAllVehicles(this.vehiclesData)
    this.clearPrevCount()
    this.getAllKhatta(id)
    this.loaderService.display(false)

    $('.background').hide()
    $('#loderImgTab').hide()
    $('#progress-bar').hide()
  }

  selectOwner(data) {}

  vehiclefilter() {
    this.loaderService.display(true)
    this.renoveAllMarker()
    this.applyFilter(this.tempVehiclesData.liveData)
    this.getCount(this.vehiclesData)
    this.plotAllVehicles(this.vehiclesData)
    this.loaderService.display(false)
  }

  applyFilter(data) {
    console.log('560', data)

    var result = []
    var result = []
    var result1 = []
    var result2 = []
    var result3 = []
    var result4 = []

    console.log(this.selectedContractorName)

    for (var i = 0; i < data.length; i++) {
      //  console.log("563",this.filterOwnerType(data[i].OwnerType),data[i].OwnerName,data[i].OwnerName);

      if (this.selectedContractorName == '') {
        if (this.filterOwnerType(data[i].OwnerType)) {
          result.push(data[i])
        }
      } else {
        if (
          this.filterOwnerType(data[i].OwnerType) &&
          data[i].OwnerName == this.selectedContractorName
        ) {
          result.push(data[i])
        }
      }
    }

    for (var i = 0; i < result.length; i++) {
      if (this.filterVehCat(result[i].vehcatname)) {
        result1.push(result[i])
      }
    }

    for (var i = 0; i < result1.length; i++) {
      if (this.filterFuelType(result1[i].FUELTYPE)) {
        result2.push(result1[i])
      }
    }

    // for (var i = 0; i < result2.length; i++) {
    //     if (this.filterZones(result2[i].zone)) {
    //         result3.push(result2[i]);
    //     }
    // }

    // this.vehiclesData = result2;
    if (this.isZoneSelected) {
      for (var i = 0; i < result2.length; i++) {
        if (result2[i].zoneid == this.zoneID) {
          result3.push(result2[i])
        }
      }
      // this.vehiclesData = result3;
      if (this.isWardSelected) {
        for (var i = 0; i < result3.length; i++) {
          if (result3[i].wardid == this.wardID) {
            result4.push(result3[i])
          }
        }
        this.vehiclesData = result4
      } else {
        this.vehiclesData = result3
      }
    } else {
      this.vehiclesData = result2
    }

    this.getStandByCount(this.vehiclesData)
    this.getMaintCount(this.vehiclesData)
  }

  filterFuelType(FUELTYPE) {
    var found = false
    if (this.filterData.fuelType.length == 0) {
      return true
    }
    for (var i = 0; i < this.filterData.fuelType.length; i++) {
      if (this.filterData.fuelType[i].name == FUELTYPE) {
        found = true
      }
    }
    this.fuelType = this.filterData.fuelType
    return found
  }

  // filterZones(zoneNames) {
  //     var found = false;
  //     if (this.filterData.zonesLi.length == 0) {
  //         return true;
  //     }
  //     for (var i = 0; i < this.filterData.zonesLi.length; i++) {
  //         if (this.filterData.zonesLi[i].name == zoneNames) {
  //             found = true;
  //         }
  //     }
  //     return found;
  // }

  filterZones(zoneNames) {
    var found = false
    if (this.filterData.zonesLi.length == 0) {
      return true
    }
    for (var i = 0; i < this.filterData.zonesLi.length; i++) {
      if (this.filterData.zonesLi[i].name == zoneNames) {
        found = true
      }
    }
    return found
  }

  filterVehCat(vehCat) {
    var found = false
    if (this.filterData.vehicleCat.length == 0) {
      return true
    }
    for (var i = 0; i < this.filterData.vehicleCat.length; i++) {
      if (this.filterData.vehicleCat[i].name == vehCat) {
        found = true
      }
    }
    this.vehCat = this.filterData.vehicleCat
    return found
  }

  filterOwnerType(ownerType) {
    var found = false
    if (this.filterData.ownerType.length == 0) {
      return true
    }
    for (var i = 0; i < this.filterData.ownerType.length; i++) {
      if (this.filterData.ownerType[i].name == ownerType) {
        found = true
      }

      // if (this.currentDate) {

      // }
    }

    // this.ownerType = this.filterData.ownerType
    return found
  }

  filterOwnerName(ownerName) {
    //console.log(this.filterData.ownerName);

    var found = false
    if (this.filterData.ownerName.length == 0) {
      return true
    }

    for (var i = 0; i < this.filterData.ownerName.length; i++) {
      console.log(
        '698',
        this.filterData.ownerName[i].OWNERNAME,
        ' - - - - -',
        ownerName,
      )

      if (this.filterData.ownerName[i].OWNERNAME == ownerName) {
        return true
      } else {
        return false
      }
    }

    // this.ownerType = this.filterData.ownerType
    //return found;
  }

  zoneFIlter(zoneData) {
    this.FixedNum = 0
    this.loaderService.display(true)
    this.renoveAllMarker()
    this.wardsList = null
    this.isWardSelected = false
    if (zoneData) {
      this.isZoneSelected = true

      this.zoneID = zoneData.ID

      this.getActualFixedNumber(zoneData.ID)
    } else {
      this.isZoneSelected = false
      //  $('').css('cursor','')
    }
    this.applyFilter(this.tempVehiclesData.liveData)
    this.getCount(this.vehiclesData)
    this.plotAllVehicles(this.vehiclesData)
    this.getWardsByZone(this.zoneID)
    this.loaderService.display(false)
  }

  async getActualFixedNumber(id) {
    let wards = await fetch(
      environment.apiUrl + 'vehicles/getActualFixedNumber' + '?id=' + id,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.totalFixedNumberVehs = await wards.json()

    this.FixedNum = this.totalFixedNumberVehs[0].totalVehicles
  }

  //onwardchange

  wardFIlter(wardData) {
    this.FixedNum = 0
    this.loaderService.display(true)

    // this.renoveAllMarker();
    if (wardData) {
      this.isWardSelected = true
      this.wardID = wardData.ID
      this.getPolygonByEntityID(wardData.ID)
      this.getActualFixedNumber(wardData.ID)
      // this.refreshAllRoutesByWard(wardData.ID);
    } else {
      this.isWardSelected = false
      this.removeEntityPolyGone()
    }
    this.applyFilter(this.tempVehiclesData.liveData)
    this.getCount(this.vehiclesData)
    this.plotAllVehicles(this.vehiclesData)
    this.loaderService.display(false)
    this.getBeatByWard(wardData.ID)
  }

  async getBeatByWard(wardId) {
    let wards = await fetch(
      environment.apiUrl + 'admin/getBeatByWard' + '?wardId=' + wardId,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.beatList = await wards.json()
  }

  beatFIlter(wardData) {
    this.loaderService.display(true)

    // this.renoveAllMarker();
    // this.removeEntityPolyGone()
    if (wardData) {
      this.isWardSelected = true
      this.wardID = wardData.ID
      // this.getPolygonByEntityID(wardData.ID)
      this.refreshAllRoutesByWard(wardData.ID)
    } else {
      // this.isWardSelected = false
      this.removeEntityPolyGone()
    }
    // this.applyFilter(this.tempVehiclesData.liveData);
    // this.getCount(this.vehiclesData);
    // this.plotAllVehicles(this.vehiclesData);
    this.loaderService.display(false)
  }

  refreshAllRoutesByWard(wid) {
    this.routePolygondData = ''
    this.http
      .get(
        environment.apiUrl +
          'entity/getAllRoutePolygons?prjid=' +
          this.prjID +
          '&wardid=' +
          wid,
      )
      .subscribe((data) => {
        var result: any
        result = data
        this.routePolygondData = result
      })
    this.map.data.addGeoJson(this.routePolygondData.geoJson)
    // this.plotRouteBoundary('10');
  }

  vehicleFilterByZone(filterData) {
    this.wardsList = null
    $('#loderImgTab').show()
    var ID
    if (filterData != null) {
      if (filterData.ID == '11111') {
        ID = null
      } else {
        ID = filterData.ID
      }
    }
    this.applyFilter(this.tempVehiclesData.liveData)
    var data = this.vehiclesData

    this.vehiclesData = []
    for (var i = 0; i < data.length; i++) {
      if (filterData != null) {
        if (data[i].zoneid == ID) {
          this.vehiclesData.push(data[i])
        }
      } else {
        this.vehiclesData.push(data[i])
      }
    }
    this.getCount(this.vehiclesData)
    this.plotAllVehicles(this.vehiclesData)
    this.getWardsByZone(ID)
    $('#loderImgTab').hide()
  }

  async getWardsByZone(id) {
    let wards = await fetch(
      environment.apiUrl + 'entity/getWardsByZoneID' + '?zoneID=' + id,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.wardsList = await wards.json()
  }

  vehicleFilterByWards(wardData) {
    $('#loderImgTab').show()
    var ID
    if (wardData != null) {
      if (wardData.ID == '11111') {
        ID = null
      } else {
        ID = wardData.ID
      }
    }
    this.applyFilter(this.tempVehiclesData.liveData)
    var data = this.vehiclesData

    this.vehiclesData = []
    for (var i = 0; i < data.length; i++) {
      if (wardData != null) {
        if (data[i].wardid == ID) {
          this.vehiclesData.push(data[i])
        }
      } else {
        this.vehiclesData.push(data[i])
      }
    }
    this.getCount(this.vehiclesData)
    this.plotAllVehicles(this.vehiclesData)
    $('#loderImgTab').hide()
  }

  async getPolygonByEntityID(entityID) {
    let polygon = await fetch(
      environment.apiUrl +
        'entity/getPolygonByEntityID' +
        '?entityID=' +
        entityID,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    var polygonData = await polygon.json()
    this.setPolygonByEntityID(polygonData.entityData[0])
  }

  setPolygonByEntityID(polygonData) {
    var data = {
      features: [{ geometry: {}, type: 'Feature', properties: '' }],
      type: '',
    }
    var d = JSON.parse(polygonData.kml)
    data.features[0].geometry = d
    var prop = JSON.parse(polygonData.properties)
    prop.type = 'clickedPolygon'
    data.features[0].properties = prop
    data.type = 'FeatureCollection'
    var color = '#B05C3C'
    this.removeEntityPolyGone()
    // this.removeOutsideMarker(polygonData.entityname);
    this.map.data.addGeoJson(data)
    this.zoomOneEntity(this.map)
  }

  zoomOneEntity(this, map) {
    this.bounds = new google.maps.LatLngBounds()
    map.data.forEach((feature) => {
      if (feature.getProperty('type') == 'clickedPolygon') {
        this.processPoints(
          feature.getGeometry(),
          this.bounds.extend,
          this.bounds,
        )
      }
    })
    map.fitBounds(this.bounds)

    this.map.data.setStyle(function (feature) {
      if (feature.getProperty('type') == 'clickedPolygon') {
        return {
          fillColor: '#666A06',
          strokeColor: '#066A0C',
          strokeWeight: 1,
          fillOpacity: 0.1,
          strokeopacity: 0.1,
        }
      }
    })
  }

  removeEntityPolyGone() {
    this.map.data.forEach((feature) => {
      if (feature.getProperty('type') == 'clickedPolygon') {
        this.map.data.remove(feature)
      }
    })
  }

  liveVehicleFuelType(sqlDb) {
    if (sqlDb.FUELTYPE == 'Diesel') {
      this.fuelTypeCount.live.diesel++
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.diesel.live++
      }
    } else if (sqlDb.FUELTYPE == 'Electric') {
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.electric.live++
      }
      this.fuelTypeCount.live.electric++
    } else if (sqlDb.FUELTYPE == 'Manual') {
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.manual.live++
      }
      this.fuelTypeCount.live.manual++
    }
  }

  offlineVehicleFuelType(sqlDb) {
    if (sqlDb.FUELTYPE == 'Diesel') {
      this.fuelTypeCount.offline.diesel++
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.diesel.offline++
      }
    } else if (sqlDb.FUELTYPE == 'Electric') {
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.electric.offline++
      }
      this.fuelTypeCount.offline.electric++
    } else if (sqlDb.FUELTYPE == 'Manual') {
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.manual.offline++
      }
      this.fuelTypeCount.offline.manual++
    }
  }

  notReceivedVehicleFuelType(sqlDb) {
    if (sqlDb.FUELTYPE == 'Diesel') {
      this.fuelTypeCount.notrunning.diesel++
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.diesel.notrunning++
      }
    } else if (sqlDb.FUELTYPE == 'Electric') {
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.electric.notrunning++
      }
      this.fuelTypeCount.notrunning.electric++
    } else if (sqlDb.FUELTYPE == 'Manual') {
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.manual.notrunning++
      }
      this.fuelTypeCount.notrunning.manual++
    }
  }

  activeVehicleFuelType(sqlDb) {
    if (sqlDb.FUELTYPE == 'Diesel') {
      this.fuelTypeCount.active.diesel++
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.diesel.active++
      }
    } else if (sqlDb.FUELTYPE == 'Electric') {
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.electric.active++
      }
      this.fuelTypeCount.active.electric++
    } else if (sqlDb.FUELTYPE == 'Manual') {
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.manual.active++
      }
      this.fuelTypeCount.active.manual++
    }
  }

  inActiveVehicleFuelType(sqlDb) {
    if (sqlDb.FUELTYPE == 'Diesel') {
      this.fuelTypeCount.inactive.diesel++
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.diesel.inactive++
      }
    } else if (sqlDb.FUELTYPE == 'Electric') {
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.electric.inactive++
      }
      this.fuelTypeCount.inactive.electric++
    } else if (sqlDb.FUELTYPE == 'Manual') {
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.manual.inactive++
      }
      this.fuelTypeCount.inactive.manual++
    }
  }

  totalVehicleFuelType(sqlDb) {
    if (sqlDb.FUELTYPE == 'Diesel') {
      this.fuelTypeCount.total.diesel++
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.diesel.total++
      }
    } else if (sqlDb.FUELTYPE == 'Electric') {
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.electric.total++
      }
      this.fuelTypeCount.total.electric++
    } else if (sqlDb.FUELTYPE == 'Manual') {
      if (sqlDb.MAINTID == 3 || sqlDb == 2) {
        this.maintenanceStatusVtsCount.ms.manual.total++
      }
      this.fuelTypeCount.total.manual++
    }
  }
  getCount(sqlDb) {
    this.maintenanceStatusVts()
    this.getFuelYypeCount()

    var totalPrm = []
    var totalSec = []

    var LIVE = 0
    var OFFLINE = 0
    var DATA_NOT_RECEIVED = 0
    var VTSINSTALLED = 0
    var VTSNOTINSTALLED = 0
    var RUNNING = 0
    var NOT_STARTED = 0
    var STOPPED = 0
    var totalRunning = 0
    var STANDBY = 0
    var MAINTENANCE = 0

    for (var i = 0; i < sqlDb.length; i++) {
      if (sqlDb[i].VTSSTATUS == 'LIVE') {
        LIVE++
      } else if (sqlDb[i].VTSSTATUS == 'OFFLINE') {
        OFFLINE++
      }

      if (sqlDb[i].RUNNING_STATUS == 'RUNNING') {
        RUNNING++
      } else if (sqlDb[i].RUNNING_STATUS == 'STOPPED') {
        STOPPED++
      } else if (sqlDb[i].RUNNING_STATUS == 'NOT_STARTED') {
        NOT_STARTED++
      } else if (sqlDb[i].RUNNING_STATUS == 'DNR') {
        DATA_NOT_RECEIVED++
      } else if (sqlDb[i].RUNNING_STATUS == 'MAINTENANCE') {
        MAINTENANCE++
      } else if (sqlDb[i].RUNNING_STATUS == 'STANDBY') {
        STANDBY++
      }

      if (sqlDb[i].VTSINSTALLED == 'YES') {
        VTSINSTALLED++
      } else if (sqlDb[i].VTSINSTALLED == 'NO') {
        VTSNOTINSTALLED++
      }
    }

    //351

    /*
       countData.TOTAL > 351
       new diffValue = countData.TOTAL-351
       new notStrat = countData.NOT_STARTED - diffValue
        mew total = 351
        new vtsTotal = 351
       */

    this.countData = {
      TOTAL: sqlDb.length,
      LIVE: RUNNING + NOT_STARTED + STOPPED,
      RUNNING: RUNNING,
      // TOTALRUNNING: totalRunning,
      NOT_STARTED: NOT_STARTED,
      STOPPED: STOPPED,
      OFFLINE: OFFLINE,
      DATA_NOT_RECEIVED: DATA_NOT_RECEIVED,
      VTSINSTALLED: VTSINSTALLED,
      VTSNOTINSTALLED: VTSNOTINSTALLED,
      MAINTENANCE: MAINTENANCE,
      STANDBY: STANDBY,
      FIXEDNUM: this.FixedNum,
    }
  }

  getStatus(mongodb, id) {
    var d1 = new Date()
    var d3 = new Date()
    var found = false
    for (var j = 0; j < mongodb.length; j++) {
      if (id == Number(mongodb[j].IMEI)) {
        found = true
        if (d3.setHours(0) < new Date(mongodb[j].HEARTBEATDATE).getTime()) {
          if (
            new Date(mongodb[j].HEARTBEATDATE).getTime() <
            d1.setHours(d1.getHours() - 2)
          ) {
            d3 = new Date()
            d1 = new Date()
            if (mongodb[j].FUELTYPE == 'Diesel') {
              this.fuelTypeCount.offline.diesel++
              if (mongodb[j].MAINTID == 3 || mongodb[j] == 2) {
                this.maintenanceStatusVtsCount.ms.diesel.offline++
              }
            } else if (mongodb[j].FUELTYPE == 'Electric') {
              if (mongodb[j].MAINTID == 3 || mongodb[j] == 2) {
                this.maintenanceStatusVtsCount.ms.electric.offline++
              }
              this.fuelTypeCount.offline.electric++
            } else if (mongodb[j].FUELTYPE == 'Manual') {
              if (mongodb[j].MAINTID == 3 || mongodb[j] == 2) {
                this.maintenanceStatusVtsCount.ms.manual.offline++
              }
              this.fuelTypeCount.offline.manual++
            }
            return 'OFFLINE'
          } else {
            if (mongodb[j].FUELTYPE == 'Diesel') {
              this.fuelTypeCount.live.diesel++
              if (mongodb[j].MAINTID == 3 || mongodb[j] == 2) {
                this.maintenanceStatusVtsCount.ms.diesel.live++
              }
            } else if (mongodb[j].FUELTYPE == 'Electric') {
              if (mongodb[j].MAINTID == 3 || mongodb[j] == 2) {
                this.maintenanceStatusVtsCount.ms.electric.live++
              }
              this.fuelTypeCount.live.electric++
            } else if (mongodb[j].FUELTYPE == 'Manual') {
              if (mongodb[j].MAINTID == 3 || mongodb[j] == 2) {
                this.maintenanceStatusVtsCount.ms.manual.live++
              }
              this.fuelTypeCount.live.manual++
            }
            d1 = new Date()
            d3 = new Date()
            return 'LIVE'
          }
        }
      }
    }
    if (!found) {
      return 'NOT RUNNING'
    }
  }
  mergeVehicleStatus(mongodb, sql) {
    for (var i = 0; i < sql.length; i++) {
      sql[i].STATUS = this.getStatus(mongodb, sql[i].IMEI)
    }
    for (var i = 0; i < this.mismatchArray.length; i++) {
      sql.push({ STATUS: 'NOT IN DB(LIVE)', IMEI: this.mismatchArray[i].IMEI })
    }
  }

  // refreshVechiclesLocation = async () => {
  //     if (!this.liveTrack) {
  //         let vehicles = await fetch(environment.apiUrl + 'vehicles/location/all' + '?prjID=' + this.prjID, {
  //             method: 'get',
  //             headers: {
  //                 Accept: 'application/json',
  //                 'Content-Type': 'application/json',
  //                 Authorization: this.authtoken.token
  //             }
  //         });
  //         this.vehiclesLocation = await vehicles.json();
  //         let vehiclesDetail = await fetch(environment.apiUrl + 'vehicles/detail' + '?prjId=' + this.prjID, {
  //             method: 'get',
  //             headers: {
  //                 Accept: 'application/json',
  //                 'Content-Type': 'application/json',
  //                 Authorization: this.authtoken.token
  //             }
  //         });
  //         this.vehiclesData = await vehiclesDetail.json();
  //         this.mergeVechiclesData();
  //         this.plotAllVehicles(this.vehiclesLocation);
  //         this.vehiclesDataTemp = this.vehiclesData;
  //         this.clearPrevCount();
  //         this.getCurrentDataStatus(this.vehiclesLocation);
  //         this.getStatusCount(this.vehiclesData);
  //         this.getMisMatchCount(this.vehiclesData, this.vehiclesLocation);
  //         this.getDeadCount(this.vehiclesData, this.vehiclesLocation);
  //         this.getStandByCount(this.vehiclesData);
  //         this.getMaintCount(this.vehiclesData);
  //     }
  // };

  getStandByCount(data) {
    var standBy = 0
    var standByArr = []
    for (var i = 0; i < data.length; i++) {
      if (data[i].MAINTID == 4) {
        standBy++
        standByArr.push(data[i])
      }
    }
    this.standBy = standBy

    var liveStandby = _.filter(standByArr, function (o) {
      return o.VTSSTATUS == 'LIVE'
    })

    this.liveStandBy = liveStandby.length
    this.DNRStandBy = standByArr.length - liveStandby.length
  }

  getMaintCount(data) {
    var MaintArr = []
    for (var i = 0; i < data.length; i++) {
      if (data[i].MAINTID == 3) {
        MaintArr.push(data[i])
      }
    }

    var liveMaint = _.filter(MaintArr, function (o) {
      return o.VTSSTATUS == 'LIVE'
    })

    this.liveMaint = liveMaint.length
    this.DNRMaint = MaintArr.length - liveMaint.length
  }

  clearPrevCount() {
    this.inactive = 0
    this.active = 0
    this.live = 0
    this.offline = 0
    this.old = 0
    this.mismatch = 0
    this.dead = 0
    this.notmoving = 0
  }

  getMaintenanceStatus() {
    $('#loderImgTab').show()
    this.applyFilter(this.tempVehiclesData.liveData)
    var data = this.vehiclesData

    this.vehiclesData = []
    for (var i = 0; i < data.length; i++) {
      if (data[i].MIANTSTATUS == 'BREAKDOWN') {
        this.vehiclesData.push(data[i])
      }
    }
    $('#loderImgTab').hide()
  }

  getStandByVehicle() {
    $('#loderImgTab').show()
    this.applyFilter(this.tempVehiclesData.liveData)
    var data = this.vehiclesData

    this.vehiclesData = []
    for (var i = 0; i < data.length; i++) {
      if (data[i].MIANTSTATUS == 'STANDBY') {
        this.vehiclesData.push(data[i])
      }
    }
    $('#loderImgTab').hide()
  }

  getVTSStatusData(status) {
    $('#loderImgTab').show()
    this.applyFilter(this.tempVehiclesData.liveData)
    var data = this.vehiclesData

    this.vehiclesData = []
    for (var i = 0; i < data.length; i++) {
      if (data[i].VTSSTATUS == status) {
        this.vehiclesData.push(data[i])
      }
    }
    $('#loderImgTab').hide()
  }

  getStatusData(status) {
    $('#loderImgTab').show()
    this.applyFilter(this.tempVehiclesData.liveData)
    var data = this.vehiclesData

    this.vehiclesData = []
    for (var i = 0; i < data.length; i++) {
      if (data[i].RUNNING_STATUS == status) {
        this.vehiclesData.push(data[i])
      }
    }
    $('#loderImgTab').hide()
  }

  getLiveStatusData(status) {
    $('#loderImgTab').show()
    this.applyFilter(this.tempVehiclesData.liveData)
    var data = this.vehiclesData

    this.vehiclesData = []
    for (var i = 0; i < data.length; i++) {
      if (
        data[i].VTSSTATUS == status &&
        data[i].MAINTID == 1 &&
        data[i].RUNNING_STATUS != 'DNR'
      ) {
        this.vehiclesData.push(data[i])
      }
    }
    $('#loderImgTab').hide()
    this.plotAllVehicles(this.vehiclesData)
  }

  getRunningStatusData(status) {
    $('#loderImgTab').show()
    this.applyFilter(this.tempVehiclesData.liveData)
    var data = this.vehiclesData

    this.vehiclesData = []
    for (var i = 0; i < data.length; i++) {
      if (data[i].RUNNING_STATUS == status) {
        this.vehiclesData.push(data[i])
      }
    }

    this.plotAllVehicles(this.vehiclesData)
    $('#loderImgTab').hide()
  }

  async Info_wardModal_btn() {
    $('#Info_wardModal').modal('show')
    this.isAssignment = true
    let area = await fetch(
      environment.apiUrl + 'vehicles/getAssignedArea' + '?VEHID=' + this.VEHID,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.areaAssignment = await area.json()

    let staff = await fetch(
      environment.apiUrl +
        'admin/getStaffAssignmentDetails' +
        '?VEHID=' +
        this.VEHID,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.isAssignment = false
    this.staffAssignment = await staff.json()

    //  route by atul

    let route = await fetch(
      environment.apiUrl +
        'admin/getRouteAssignmentDetails' +
        '?VEHID=' +
        this.VEHID,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )

    //this.isAssignment = false
    //this.staffAssignment = false
    this.routeAssignment = await route.json()

    $('.background').hide()
  }

  getVtsInstalled(status) {
    $('#loderImgTab').show()
    this.applyFilter(this.tempVehiclesData.liveData)
    var data = this.vehiclesData

    this.vehiclesData = []
    for (var i = 0; i < data.length; i++) {
      if (data[i].VTSINSTALLED == status) {
        this.vehiclesData.push(data[i])
      }
    }
    $('#loderImgTab').hide()
  }

  totalVehicle() {
    $('#loderImgTab').show()
    this.applyFilter(this.tempVehiclesData.liveData)

    $('#loderImgTab').hide()
  }

  notInDbVehicle() {
    $('#loderImgTab').show()
    this.vehiclesData = this.notInDb

    $('#loderImgTab').hide()
  }

  //  vehicle fuel type  count

  getFuelYypeCount() {
    this.fuelTypeCount = {
      total: {
        diesel: 0,
        electric: 0,
        manual: 0,
      },
      inactive: {
        diesel: 0,
        electric: 0,
        manual: 0,
      },
      active: {
        diesel: 0,
        electric: 0,
        manual: 0,
      },
      live: {
        diesel: 0,
        electric: 0,
        manual: 0,
      },
      offline: {
        diesel: 0,
        electric: 0,
        manual: 0,
      },
      notrunning: {
        diesel: 0,
        electric: 0,
        manual: 0,
      },
    }
  }

  maintenanceStatus() {
    this.maintenanceStatusCount = {
      ms: {
        diesel: 0,
        electric: 0,
        manual: 0,
      },
      standBy: {
        diesel: 0,
        electric: 0,
        manual: 0,
      },
    }
  }

  maintenanceStatusVts() {
    this.maintenanceStatusVtsCount = {
      ms: {
        diesel: {
          total: 0,
          live: 0,
          offline: 0,
          active: 0,
          inactive: 0,
          notrunning: 0,
        },
        electric: {
          total: 0,
          live: 0,
          offline: 0,
          active: 0,
          inactive: 0,
          notrunning: 0,
        },
        manual: {
          total: 0,
          live: 0,
          offline: 0,
          active: 0,
          inactive: 0,
          notrunning: 0,
        },
      },
      standBy: {
        diesel: {
          total: 0,
          live: 0,
          offline: 0,
          active: 0,
          inactive: 0,
          notrunning: 0,
        },
        electric: {
          total: 0,
          live: 0,
          offline: 0,
          active: 0,
          inactive: 0,
          notrunning: 0,
        },
        manual: {
          total: 0,
          live: 0,
          offline: 0,
          active: 0,
          inactive: 0,
          notrunning: 0,
        },
      },
    }
  }

  findLiveInNotInDbArray(data) {
    var d1 = new Date()
    var d3 = new Date()
    this.liveArray = []
    this.notInDbAndOfflineArray = []
    this.notInDbAndLiveArray = []
    d3.setHours(0)
    let notInDbAndOffline = 0
    let notInDbAndLive = 0
    d1.setHours(d1.getHours() - 2)
    data.forEach((element) => {
      var d2 = new Date(element.DATE).getTime()
      if (d3.setHours(0) < new Date(element.HEARTBEATDATE).getTime()) {
        if (
          new Date(element.HEARTBEATDATE).getTime() <
          d1.setHours(d1.getHours() - 2)
        ) {
          notInDbAndOffline++
          element.STATUS = 'OFFLINE'
          this.notInDbAndOfflineArray.push(element)
          d3 = new Date()
          d1 = new Date()
        } else {
          notInDbAndLive++
          element.STATUS = 'LIVE'
          this.notInDbAndLiveArray.push(element)
          d1 = new Date()
          d3 = new Date()
        }
      }
    })
    this.notInDbAndOffline = notInDbAndOffline
    this.notInDbAndLive = notInDbAndLive
  }
  getDeadAndLiveCount(dead, allLive) {
    var deadAndLive = []
    for (var i = 0; i < dead.length; i++) {
      for (var j = 0; i < allLive.length; i++) {
        if (allLive[i].DEVICEID == dead[j].IMEI) {
          deadAndLive.push(allLive[i])
        }
      }
      this.deadAndLive = deadAndLive
    }
  }
  getMisMatchCount(sqlDb, currentData) {
    var mismatch = 0
    var dataWithoutDead = []
    this.mismatchArray = []
    for (var i = 0; i < currentData.length; i++) {
      currentData[i].IMEI = currentData[i].DEVICEID
      var found = false
      for (var j = 0; j < sqlDb.length; j++) {
        if (currentData[i].DEVICEID == sqlDb[j].IMEI) {
          found = true
          dataWithoutDead.push(currentData[i])
        } else {
        }
      }
      if (!found) {
        mismatch++
        currentData[i].STATUS = 'NOT IN DB'
        this.mismatchArray.push(currentData[i])
      }
    }
    this.dataWithoutDead = dataWithoutDead
    this.mismatch = mismatch
  }
  getDeadCount(sqlDb, currentData) {
    var dead = 0
    var activeAndLive = []
    this.deadArray = []
    for (var i = 0; i < sqlDb.length; i++) {
      var found = false
      for (var j = 0; j < currentData.length; j++) {
        if (sqlDb[i].IMEI == currentData[j].DEVICEID) {
          found = true
          activeAndLive.push(sqlDb[i])
          break
        }
      }
      if (!found) {
        dead++
        sqlDb[i].STATUS = 'NOT RUNNING'
        if (sqlDb[i].STATUS == 'NOT RUNNING') {
          if (sqlDb[i].FUELTYPE == 'Diesel') {
            if (sqlDb[i].MAINTID == 3 || sqlDb[i].MAINTID == 2) {
              this.maintenanceStatusVtsCount.ms.diesel.notrunning++
            }
            this.fuelTypeCount.notrunning.diesel++
          } else if (sqlDb[i].FUELTYPE == 'Electric') {
            if (sqlDb[i].MAINTID == 3 || sqlDb[i].MAINTID == 2) {
              this.maintenanceStatusVtsCount.ms.electric.notrunning++
            }
            this.fuelTypeCount.notrunning.electric++
          } else if (sqlDb[i].FUELTYPE == 'Manual') {
            if (sqlDb[i].MAINTID == 3 || sqlDb[i].MAINTID == 2) {
              this.maintenanceStatusVtsCount.ms.manual.notrunning++
            }

            this.fuelTypeCount.notrunning.manual++
          }
        }
        this.deadArray.push(sqlDb[i])
      }
    }
    this.activeAndLive = activeAndLive
    this.dead = dead
  }
  currentStatus(data) {
    var d1 = new Date()
    var d3 = new Date()
    this.liveArray = []
    this.offlineArray = []
    this.oldArray = []
    d3.setHours(0)
    let live = 0
    let offline = 0
    let old = 0
    let notmoving = 0
    d1.setHours(d1.getHours() - 2)
    data.forEach((element) => {
      var d2 = new Date(element.DATE).getTime()
      if (
        new Date(element.HEARTBEATDATE).getTime() <
        d1.setHours(d1.getHours() - 2)
      ) {
        offline++
        element.STATUS = 'OFFLINE'
        this.offlineArray.push(element)
        d3 = new Date()
        d1 = new Date()
      } else {
        live++
        element.STATUS = 'LIVE'
        this.liveArray.push(element)
        d1 = new Date()
        d3 = new Date()
      }
      if (
        new Date(element.SYSTEMDATE).getDate() <
        new Date(element.HEARTBEATDATE).getDate()
      ) {
        notmoving++
        let data = element
        data.STATUS = 'NOTMOVING'
        this.notmovingArray.push(data)
        d3 = new Date()
        d1 = new Date()
      }
    })

    var actualLive = live - (live + offline + this.dead - this.active)
    this.old = old
    this.live = actualLive
    this.offline = offline
    this.notmoving = notmoving
  }
  getCurrentDataStatus(data) {
    var d1 = new Date()
    var d3 = new Date()
    this.liveArray = []
    this.offlineArray = []
    this.oldArray = []
    d3.setHours(0)
    let live = 0
    let offline = 0
    let old = 0
    let notmoving = 0
    d1.setHours(d1.getHours() - 2)
    data.forEach((element) => {
      var d2 = new Date(element.DATE).getTime()
      if (d3.setHours(0) < new Date(element.HEARTBEATDATE).getTime()) {
        if (
          new Date(element.HEARTBEATDATE).getTime() <
          d1.setHours(d1.getHours() - 2)
        ) {
          offline++
          element.STATUS = 'OFFLINE'
          this.offlineArray.push(element)
          d3 = new Date()
          d1 = new Date()
        } else {
          live++
          element.STATUS = 'LIVE'
          this.liveArray.push(element)
          d1 = new Date()
          d3 = new Date()
        }
        if (
          new Date(element.SYSTEMDATE).getDate() <
          new Date(element.HEARTBEATDATE).getDate()
        ) {
          notmoving++
          let data = element
          data.STATUS = 'NOTMOVING'
          this.notmovingArray.push(data)
          d3 = new Date()
          d1 = new Date()
        }
      } else {
        d1 = new Date()
        d3 = new Date()
        old++
        element.STATUS = 'OLD'
        this.oldArray.push(element)
      }
    })
    this.old = old
    this.live = live
    this.offline = offline
    this.notmoving = notmoving
  }

  getStatusCount(data) {
    var inactive = 0
    var active = 0
    this.activeArray = []
    this.inactiveArray = []
    this.all = data.length
    data.forEach((element) => {
      if (!element.IMEI) {
        inactive++
        element.STATUS = 'INACTIVE'
        if (element.FUELTYPE == 'Diesel') {
          if (element.MAINTID == 3 || element.MAINTID == 2) {
            this.maintenanceStatusVtsCount.ms.diesel.inactive++
          }
          this.fuelTypeCount.inactive.diesel++
        } else if (element.FUELTYPE == 'Electric') {
          if (element.MAINTID == 3 || element.MAINTID == 2) {
            this.maintenanceStatusVtsCount.ms.electric.inactive++
          }
          this.fuelTypeCount.inactive.electric++
        } else if (element.FUELTYPE == 'Manual') {
          if (element.MAINTID == 3 || element.MAINTID == 2) {
            this.maintenanceStatusVtsCount.ms.manual.inactive++
          }
          this.fuelTypeCount.inactive.manual++
        }
        this.inactiveArray.push(element)
      }
      if (element.IMEI) {
        active++
        element.STATUS = 'ACTIVE'

        if (element.FUELTYPE == 'Diesel') {
          this.fuelTypeCount.active.diesel++
          if (element.MAINTID == 3 || element.MAINTID == 2) {
            this.maintenanceStatusVtsCount.ms.diesel.active++
          }
        } else if (element.FUELTYPE == 'Electric') {
          if (element.MAINTID == 3 || element.MAINTID == 2) {
            this.maintenanceStatusVtsCount.ms.electric.active++
          }
          this.fuelTypeCount.active.electric++
        } else if (element.FUELTYPE == 'Manual') {
          if (element.MAINTID == 3 || element.MAINTID == 2) {
            this.maintenanceStatusVtsCount.ms.manual.active++
          }
          this.fuelTypeCount.active.manual++
        }
        this.activeArray.push(element)
      }
    })
    this.inactive = inactive
    this.active = active
  }

  // liveTrack() {
  //     if (this.isLive) {
  //         this.isLive = false;
  //     } else {
  //         this.renoveAllMarker();
  //         this.route.setMap(null);
  //         this.plotRouteWhenLiveTrack();
  //         this.isLive = true;
  //     }
  // }

  deleteMarker(id, mylatlongs, ANGLE) {
    if (this.allMarkers.length > 0) {
      for (var i = 0; i < this.allMarkers.length; i++) {
        if (this.allMarkers[i].id == id) {
          if (this.isLive) {
            var car =
              'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
            var icon = {
              path: car,
              scale: 0.7,
              strokeColor: 'white',
              strokeWeight: 0.11,
              fillOpacity: 1,
              fillColor: '#404040',
              offset: '4%',
              rotation: ANGLE, //<-- Car angle
            }
            this.allMarkers[i].setIcon(icon)
            this.allMarkers[i].setVisible(true)
            this.allMarkers[i].setPosition(mylatlongs)
            // this.plotTransition(this.allMarkers[i], mylatlongs, id)
            //this.allMarkers.splice(i, 1)
          }
          // this.allMarkers[i].setPosition(mylatlongs);
        }
      }
    }
  }

  renoveAllMarker() {
    if (this.allMarkers.length > 0) {
      for (var i = 0; i < this.allMarkers.length; i++) {
        this.allMarkers[i].setVisible(false)
      }
    }
  }
  plotAllMarkerOnClose() {
    if (this.allMarkers.length > 0) {
      for (var i = 0; i < this.allMarkers.length; i++) {
        this.allMarkers[i].setVisible(true)
      }
    }
  }
  plotTransition(startMarker, endMarker, id) {
    var last = startMarker.position.lat() + ',' + startMarker.position.lng()
    var first = endMarker.lat() + ',' + endMarker.lng()
    this.http
      .get(
        environment.apiUrl +
          'vehicles/transition' +
          '?first=' +
          last +
          '&last=' +
          first,
      )
      .subscribe((data) => {
        let result: any
        result = data
        this.autoRefreshLiveData(this.map, result.overview_polyline, id)
      })
  }
  plotMarker(point, DEVICEID, DEVICEDATE) {
    var car =
      'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
    var lineSymbol = {
      path: car,
      scale: 0.7,
      strokeColor: 'white',
      strokeWeight: 0.1,
      fillOpacity: 1,
      fillColor: '#0B0104',
      offset: '5%',
      anchor: new google.maps.Point(10, 25), // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
    }
    this.markerStart = new google.maps.Marker({
      position: point,
      map: this.map,
      icon: lineSymbol,
      title: DEVICEID + '(' + DEVICEDATE + ')',
    })
    this.markerStart.id = DEVICEID
    this.markerStart.setMap(this.map)
    this.allMarkers.push(this.markerStart)
  }

  transition(result) {
    var i = 0
    var deltaLat = (result[0] - this.position[0]) / 100
    var deltaLng = (result[1] - this.position[1]) / 100
    this.moveMarker(deltaLat, deltaLng)
  }

  moveMarker(deltaLat, deltaLng) {
    this.position[0] += deltaLat
    this.position[1] += deltaLng
    var latlng = new google.maps.LatLng(this.position[0], this.position[1])
    this.markerStart.setPosition(latlng)
    var i = 0
    if (i != 100) {
      i++
      setTimeout(this.moveMarker, 10)
    }
  }

  plotAllVehicles(data) {
    var locations = []
    var thisRef = this
    var infoWindow = new google.maps.InfoWindow()
    var bounds = new google.maps.LatLngBounds()
    var icon
    var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    if (this.markerCluster) {
      this.markerCluster.clearMarkers()
    }

    this.renoveAllMarker()
    var markers = []
    var car =
      'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
    for (var i = 0; i < data.length; i++) {
      if (data[i].LAT && data[i].LONG) {
        if (data[i].RUNNING_STATUS == 'RUNNING') {
          var color = '#4AA951'
        } else if (data[i].RUNNING_STATUS == 'STOPPED') {
          var color = '#DF8F1C'
        } else if (data[i].RUNNING_STATUS == 'NOT_STARTED') {
          var color = '#A9525E'
        }

        var item = data[i]
        if (!item.ANGLE) {
          var rotation = 0
        } else {
          rotation = item.ANGLE
        }

        icon = {
          path: car,
          scale: 0.7,
          strokeColor: 'black',
          strokeWeight: 1,
          fillOpacity: 1,
          fillColor: color,
          offset: '1%',
          rotation: rotation, //<-- Car angle
        }

        if (item.LAT && item.LONG) {
          if (item.RUNNINGWARD != item.ward) {
            if (item.OwnerType == 'Contractor') {
              var marker = new google.maps.Marker({
                position: {
                  lat: JSON.parse(item.LAT),
                  lng: JSON.parse(item.LONG),
                },
                icon: icon,
                label: {
                  text: 'X/C',
                  icon: car,
                  color: '#D03207',
                  fontSize: '12px',
                  labelAnchor: new google.maps.Point(25, 65),
                  background: 'yellow',
                  fontWeight: 'bold',
                },
              })
            } else {
              var marker = new google.maps.Marker({
                position: {
                  lat: JSON.parse(item.LAT),
                  lng: JSON.parse(item.LONG),
                },
                icon: icon,
                label: {
                  text: 'X',
                  icon: car,
                  color: '#D03207',
                  fontSize: '16px',
                  labelAnchor: new google.maps.Point(25, 65),
                  background: 'yellow',
                  fontWeight: 'bold',
                },
              })
            }
          } else {
            if (item.OwnerType == 'Contractor') {
              var marker = new google.maps.Marker({
                position: {
                  lat: JSON.parse(item.LAT),
                  lng: JSON.parse(item.LONG),
                },
                icon: icon,
                label: {
                  text: 'C',
                  icon: car,
                  color: '#D03207',
                  fontSize: '16px',
                  labelAnchor: new google.maps.Point(25, 65),
                  background: 'yellow',
                  fontWeight: 'bold',
                },
              })
            } else {
              var marker = new google.maps.Marker({
                position: {
                  lat: JSON.parse(item.LAT),
                  lng: JSON.parse(item.LONG),
                },
                icon: icon,
              })
            }
          }

          marker.id = item.IMEI
          marker.vehid = item.id
          marker.vehno = item.vehno
          marker.SPEED = item.SPEED
          marker.dateTime = item.HEARTBEATDATE
          marker.type = item.vehtypname
          marker.WARD = item.RUNNINGWARD
          marker.ZONE = item.RUNNINGZONE

          marker.assignWard = item.ward

          marker.MIANTSTATUS = item.MIANTSTATUS

          markers.push(marker)
          this.allMarkers.push(marker)
          if (!this.vehicleCluster) {
            marker.setMap(this.map)
          }
        }
        ;(function (marker, data) {
          google.maps.event.addListener(marker, 'click', function (e) {
            thisRef.isClickedVehicle = data.IMEI

            //Wrap the content inside an HTML DIV in order to set height and width of InfoWindow.
            var content =
              "<div class='col-sm-12 '>" +
              "</p><p class='info-deatil'><strong>Vehicle No: </strong>" +
              '  ' +
              marker.vehno +
              ' ( ' +
              marker.type +
              ' ) ' +
              "</p><p class='info-deatil'><strong>Assign Ward:</strong>" +
              '  ' +
              marker.assignWard +
              "</p><p class='info-deatil'><strong>Running Ward:</strong>" +
              '  ' +
              marker.WARD +
              "</p><p class='info-deatil'><strong>Status</strong>" +
              '  ' +
              marker.MIANTSTATUS +
              "</p><p class='info-deatil'><strong>Speed:</strong>" +
              '  ' +
              marker.SPEED +
              ' ' +
              'Km/h' +
              "</p><p class='info-deatil'><strong>Last Updated: </strong>" +
              '  ' +
              marker.dateTime +
              ' ' +
              // "</p><p class='info-deatil'><strong>Area :</strong>" + "  " + marker.BEAT + "</p> " +
              '</div>'
            infoWindow.setContent(content)
            infoWindow.open(this.map, marker)
          })
        })(marker, item)
      }
    }
    if (this.vehicleCluster) {
      this.markerCluster = new MarkerClusterer(this.map, markers, {
        imagePath:
          'HttpClient s://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      })
    }
  }

  processPoints(this, geometry, callback, thisArg) {
    if (geometry instanceof google.maps.LatLng) {
      callback.call(thisArg, geometry)
    } else if (geometry instanceof google.maps.Data.Point) {
      callback.call(thisArg, geometry.get())
    } else {
      if (geometry) {
        geometry.getArray().forEach((g) => {
          this.processPoints(g, callback, thisArg)
        })
      }
    }
  }

  zoom(this, map, isZone) {
    this.bounds = new google.maps.LatLngBounds()
    this.map.data.forEach((feature) => {
      if (isZone) {
        this.processPoints(
          feature.getGeometry(),
          this.bounds.extend,
          this.bounds,
        )
      } else {
        if (feature.getProperty('type') == 'route') {
          this.processPoints(
            feature.getGeometry(),
            this.bounds.extend,
            this.bounds,
          )
        }
      }
    })
    map.fitBounds(this.bounds)
  }

  dateChanged() {
    // this.getDataWhenProjectChange(this.prjID);
    // this.downloadReport()
    //this.fixDate()

    let selectedDate = moment(this.date).format('YYYY-MM-DD')

    this.downloadReportDate = selectedDate
  }

  reload() {
    $('#loderImgTab').hide()
    $('#infotable1').hide()
    $('#infotable2').hide()
    $('#statusTable').show()
    $('#play').show()
    $('#stop').hide()
    $('#veichiclesInfo-bar').hide()
    $('#progress-bar').hide()
    this.removeMultiRoute()
    this.removeLine()
    this.removeMarker()
    this.clearStopMarker()
    this.getDataWhenProjectChange(this.prjID)
    this.vechicleListIsClicked = false

    this.test
  }

  removeAssignRoute() {
    this.map.data.forEach((feature) => {
      if (feature.getProperty('Oemid') == 10) {
        this.map.data.remove(feature)
      }
    })
  }

  getAssignroute(id, IMEI) {
    this.removeAssignRoute()

    this.http
      .get(environment.apiUrl + 'entity/getVehicleroute?' + 'vehId=' + id)
      .subscribe((data) => {
        var result: any
        result = data

        //console.log('2055',result);

        this.map.data.addGeoJson(result.geoJson)
      })
  }

  getAssignSecPoint(id, vehNo) {
    this.http
      .get(environment.apiUrl + 'vehicles/getAssignedSecPoint?' + 'vehId=' + id)
      .subscribe((data) => {
        this.getTripCount(data, vehNo)
      })
  }

  getTripCount(data, vehNo) {
    if (data.length > 0) {
      data[0].vehNo = vehNo
      this.tripData = {}
      let date = moment().format('YYYY-MM-DD')
      data[0].date = date
      this.http
        .post(environment.apiUrl + 'vehicles/getTrip', data[0])
        .subscribe((data) => {
          this.tripData = data[0]
        })
    } else {
      this.tripData = {}
    }
  }

  createPopupClass() {
    /**
     * A customized popup on the map.
     * @param {!google.maps.LatLng} position
     * @param {!Element} content The bubble div.
     * @constructor
     * @extends {google.maps.OverlayView}
     */
    function Popup(position, content) {
      this.position = position

      content.classList.add('popup-bubble')

      // This zero-height div is positioned at the bottom of the bubble.
      var bubbleAnchor = document.createElement('div')
      bubbleAnchor.classList.add('popup-bubble-anchor')
      bubbleAnchor.appendChild(content)

      // This zero-height div is positioned at the bottom of the tip.
      this.containerDiv = document.createElement('div')
      this.containerDiv.classList.add('popup-container')
      this.containerDiv.appendChild(bubbleAnchor)

      // Optionally stop clicks, etc., from bubbling up to the map.
      google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv)
    }
    // ES5 magic to extend google.maps.OverlayView.
    Popup.prototype = Object.create(google.maps.OverlayView.prototype)

    /** Called when the popup is added to the map. */
    Popup.prototype.onAdd = function () {
      this.getPanes().floatPane.appendChild(this.containerDiv)
    }

    /** Called when the popup is removed from the map. */
    Popup.prototype.onRemove = function () {
      if (this.containerDiv.parentElement) {
        this.containerDiv.parentElement.removeChild(this.containerDiv)
      }
    }

    /** Called each frame when the popup needs to draw itself. */
    Popup.prototype.draw = function () {
      var divPosition = this.getProjection().fromLatLngToDivPixel(this.position)

      // Hide the popup when it is far out of view.
      var display =
        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
          ? 'block'
          : 'none'

      if (display === 'block') {
        this.containerDiv.style.left = divPosition.x + 'px'
        this.containerDiv.style.top = divPosition.y + 'px'
      }
      if (this.containerDiv.style.display !== display) {
        this.containerDiv.style.display = display
      }
    }

    return Popup
  }

  optimizeRoute() {
    if (this.routeAccuracy) {
      this.routeAccuracy = false
    } else {
      this.routeAccuracy = true
    }
    if (this.vechicleListIsClicked) {
    }
  }

  plotRoute = async (data, index) => {
    this.removeLine()
    this.clearCurrentVehicalInfo()
    this.isVehicleClicked = true

    if (data.MAINTID == 3) {
      this.isUnderMaintenance = true
    }
    if (data.MAINTID == 1) {
      this.isUnderMaintenance = false
    }
    this.highLightAssignBeat(data.wardid)
    this.getAssignroute(data.id, data.IMEI)
    this.getAssignSecPoint(data.id, data.vehno)
    this.loaderService.display(true)
    this.vechicleListIsClicked = true
    this.IEMI = data.IMEI
    this.VEHID = data.id
    this.VEHNO = data.vehno
    this.mobileNo = data.vtsmobileno
    this.servingWardName = ''
    this.assignWard = data.ward

    $('#infotable1').hide()
    $('#infotable2').hide()

    this.renoveAllMarker()
    let date = moment(this.selectedDatenew).format('YYYY-MM-DD')
    this.selectedlist = index
    let response = await fetch(
      environment.apiUrl +
        'vehicles/route' +
        '?DEVICEID=' +
        data.IMEI +
        '&prjId=' +
        this.prjID +
        '&date=' +
        date +
        '&accuracy=' +
        this.routeAccuracy,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    let result = await response.json()
    this.loaderService.display(false)
    // this.openNav();
    $('#mySidenav').css('width', '295px')
    if (result.status == 'No Route Found') {
      this.removeMarker()
      this.getPrevDayLocation(data)
      if (result.data.length > 0) {
        this.showCurrentVehiclesInfo(result.data[0], data)
        this.locateVehicle(result.data[0].STARTPOINT)
        this.plotStartAndEndPoint(result.data[0])
        this.totalStop = 0
        this.totalDuration = 0 + ': ' + 0 + '(hh:mm)'
        $('#infotable1').show()
        $('#infotable2').show()
      } else {
        this.removeMarker()
        $('#infotable1').hide()
        $('#infotable2').hide()
      }

      $('#statusTable').show()
      $('#veichiclesInfo-bar').hide()
      this.clearStopMarker()
      this.removeMultiRoute()
      this.removeLine()
      // alert(result.status);
      Swal({
        type: 'error',
        title: 'Oops...',
        text: result.status,
      })
      return
    } else {
      // $("#statusTable").hide()
      $('#infotable1').show()
      $('#infotable2').show()
      // this.removeLine();
      //  this.removeMultiRoute();
      // this.createRouteChunk(result.path)
      //this.zoomToObject(this.route)

      this.createRoute(this.map, result.latLong)
      //

      this.showCurrentVehiclesInfo(result, data)
      this.removeMarker()
      this.plotStartAndEndPoint(result)

      let stopInfo = await fetch(
        environment.apiUrl +
          'getStopInfo?DEVICEID=' +
          data.IMEI +
          '&DEVICEDATE=' +
          date,
        {
          method: 'get',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: this.authtoken.token,
          },
        },
      )
      let stop_info_data = await stopInfo.json()

      this.plotStopPosition(stop_info_data)

      let res = await fetch(
        environment.apiUrl +
          'vehicles/getServingArea' +
          '?DEVICEID=' +
          data.IMEI +
          '&prjId=' +
          this.prjID +
          '&date=' +
          date,
        {
          method: 'get',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: this.authtoken.token,
          },
        },
      )
      var servingWard = await res.json()
      this.servingWardName = servingWard.wardName
    }
  }

  // endPlotroute

  // openNav() {

  // }

  // closeNav() {
  //     closeLiveTracking

  // }

  removeAssignRouteNewVersion() {
    this.map.data.forEach((feature) => {
      this.map.data.remove(feature)
    })
  }

  getPrevDayLocation = async (data) => {
    let res = await fetch(
      environment.apiUrl +
        'vehicles/getPrevDayLocation' +
        '?DEVICEID=' +
        data.IMEI +
        '&prjId=' +
        this.prjID,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    var lastActive = await res.json()
    if (lastActive.length > 0) {
      $('#infotable1').show()
      $('#infotable2').show()
      this.distance = 0
      this.vehiclesNo = data.vehno
      this.vehiclesType = data.vehtypname
      this.startTime = 'NA'
      this.endTime = 'NA'
      this.totalStop = 0
      this.totalDuration = 0
      this.lastActiveTime = moment(new Date(lastActive[0].lastActiveDate))
        .startOf('hour')
        .fromNow()
      var latlng = {
        lat: lastActive[0].lastLocation.coordinates[1],
        lng: lastActive[0].lastLocation.coordinates[0],
      }
      this.geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === 'OK') {
          this.currentAddress = results[0].formatted_address
        }
      })

      var start = new google.maps.LatLng(
        lastActive[0].lastLocation.coordinates[1],
        lastActive[0].lastLocation.coordinates[0],
      )
      this.markerStart = new google.maps.Marker({
        position: start,
        map: this.map,
        icon: 'assets/img/start.png',
        labelClass: 'labels', // the CSS class for the label
        labelStyle: { opacity: 1.0 },
      })
      var position = {
        LAT: lastActive[0].lastLocation.coordinates[1],
        LONG: lastActive[0].lastLocation.coordinates[0],
      }
      this.locateVehicle(position)
    }
  }

  closeInfo() {
    $('.individual_detail').slideToggle()
    $('#mySidenav').toggleClass('width')
    // $('#individual_detail').css('display','none')
    $('.fa-chevron-right').toggleClass('fa-chevron-left')
  }
  getGeoLocation(lat, LONG, i, data) {
    var latlng = { lat: lat, lng: LONG }
    this.geocoder.geocode(
      { location: latlng, result_type: 'street_address' },
      (results, status) => {
        if (status === 'OK') {
          var result = results[0].formatted_address
          var address =
            result.split(',')[0] +
            ' ' +
            result.split(',')[1] +
            +' ' +
            result.split(',')[2]
          this.stopSummary[i].address = address
        }
      },
    )
  }
  getStopSummary() {
    this.isCustomLoading = true
    $('#stopSummary').modal('show')
    let date = moment().format('YYYY-MM-DD')
    this.http
      .get(
        environment.apiUrl +
          'vehicle/stopSummary?' +
          'prjId=' +
          this.prjID +
          '&deviceId=' +
          this.IEMI +
          '&date=' +
          date,
      )
      .subscribe((data) => {
        this.stopSummary = data
        //console.log(this.stopSummary);

        // this.importToExcel(data,"StopSummarReport");

        this.getTotalStopsInBeat(this.stopSummary)
        this.isCustomLoading = false
      })
  }

  // ///// new route bya atul
  newRoute() {
    this.isCustomLoading = true
    $('#newRoute').modal('show')
    let date = moment().format('YYYY-MM-DD')
    this.http
      .get(
        environment.apiUrl +
          'vehicle/getVehicleCoveredRoutesInfo?' +
          'prjId=' +
          this.prjID +
          '&DEVICEID=' +
          this.IEMI +
          '&DEVICEDATE=' +
          date,
      )
      .subscribe((data) => {
        this.newRouteData = data

        ///    t_work km calculation statrt

        var len = Object.keys(this.newRouteData).length

        var routeid = []

        for (var j = 0; j < len; j++) {
          routeid.push({
            lat: this.newRouteData[j].LAT,
            lng: this.newRouteData[j].LONG,
          })
        }

        var newCords = new google.maps.Polyline({
          path: routeid,
          strokeColor: '#121C11',
          strokeOpacity: 0.0,
          strokeWeight: 0,
          //map: this.map
        })

        var testing = google.maps.geometry.spherical.computeLength(
          newCords.getPath(),
        )

        this.NewKM = Math.ceil(testing / 1000)

        //console.log('2428',testing);

        ///    t_work km calculation statrt  end

        //console.log('2407',this.newRouteData);

        this.isCustomLoading = false
      })
  }

  closeLiveTracking() {
    this.isVehicleClicked = false
    $('#mySidenav').css('width', '0px')
    // closeInfo
    // $('#infotable1').hide();
    this.plotAllMarkerOnClose()
    this.clearCurrentVehicalInfo()
    this.removeMarker()
    this.removeLine()
    this.clearStopMarker()
  }

  printPdf(): void {
    let printContents, popupWin
    printContents = document.getElementById('print-section').innerHTML

    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto')
    popupWin.document.open()
    popupWin.document.write(`
      <html>
        <head>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`)
    popupWin.document.close()
  }
  getTotalStopsInBeat(data) {
    var stop = 0
    for (var i = 0; i < data.length; i++) {
      stop = stop + data[i].totalStops
    }
    this.totalStopBeat = stop
  }

  getTrip(imei) {
    this.http
      .get(environment.apiUrl + 'vehicles/getTrip' + '?imei=' + imei)
      .subscribe((data) => {
        let result = data
      })
  }
  async getEngineOffLocation(IMEI, date) {
    let engineOff = await fetch(
      environment.apiUrl +
        'getEngineOffLocation?DEVICEID=' +
        IMEI +
        '&DEVICEDATE=' +
        date,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    let engineOffData = await engineOff.json()
    this.plotEngineOffLocation(engineOffData)
  }

  searchVehicle(event: any) {
    // without type info
    let values: any
    values = event.target.value
    if (values) {
      if (values.length >= 4) {
        this.vehiclesData.forEach((e) => {
          if (e.vehno.includes(values)) {
            this.removeNonSearachedVehicle(e.id)
          }
        })
      }
    }
    if (!this.isVehicleClicked) {
      if (values == '' || values.length < 4) {
        // this.plotAllVehicles(this.tempVehiclesData);
        for (var i = 0; i < this.allMarkers.length; i++) {
          this.allMarkers[i].setVisible(true)
        }
      }
    }
  }

  removeNonSearachedVehicle(id) {
    if (this.allMarkers.length > 0) {
      for (var i = 0; i < this.allMarkers.length; i++) {
        if (this.allMarkers[i].vehid != id) {
          this.allMarkers[i].setVisible(false)
        }
      }
    }
  }

  getAllKhatta(prjID) {
    this.http
      .get(
        environment.apiUrl +
          'admin/getKhattaDetailsByProject' +
          '?PRJID=' +
          prjID,
      )
      .subscribe((data) => {
        let result = data
        this.secondaryPointData = result
        var pcts = 0
        var fcts = 0
        var parking = 0
        var bins = 0
        var plant = 0
        var khatta = 0
        var closed = 0
        var mts = 0

        this.secondaryPointData.forEach((e) => {
          e.OEMID == 11
            ? pcts++
            : e.OEMID == 12
            ? fcts++
            : e.OEMID == 13
            ? parking++
            : e.OEMID == 14
            ? bins++
            : e.OEMID == 15
            ? plant++
            : e.OEMID == 40
            ? khatta++
            : e.OEMID == 41
            ? khatta++
            : e.OEMID == 40 && e.IsClosed
            ? closed++
            : mts++
        })

        this.totalPCTS = pcts
        this.totalFCTS = fcts
        this.totalPARKING = parking
        this.totalBINS = bins
        this.totalPLANT = plant
        this.totalKHATTA = khatta
        this.totalCLOSED = closed
        this.totalMTS = mts
        //this.plotAllKhatta(result)
      })
  }

  plotKhattaLoc(id) {
    if (this.plotKhattaPoint) {
      this.plotAllKhatta(this.secondaryPointData)
    } else {
      this.removeSecPoint(id)
    }
  }

  plotClosedKhattaLoc(id) {
    if (this.plotClosedKhattaPoint) {
      this.plotAllKhatta(this.secondaryPointData)
    } else {
      this.removeSecPoint(id)
    }
  }

  plotParkingPoint(id) {
    if (this.plotParking) {
      this.plotAllKhatta(this.secondaryPointData)
    } else {
      this.removeSecPoint(id)
    }
  }
  plotFCTSpoint(id) {
    if (this.plotFCTS) {
      this.plotAllKhatta(this.secondaryPointData)
    } else {
      this.removeSecPoint(id)
    }
  }
  plotPCTSPoint(id) {
    if (this.plotPCTS) {
      this.plotAllKhatta(this.secondaryPointData)
    } else {
      this.removeSecPoint(id)
    }
  }
  plotPlantPoint(id) {
    if (this.plotPlant) {
      this.plotAllKhatta(this.secondaryPointData)
    } else {
      this.removeSecPoint(id)
    }
  }

  plotMTSPoint(id) {
    if (this.plotMTS) {
      this.plotAllKhatta(this.secondaryPointData)
    } else {
      this.removeSecPoint(id)
    }
  }

  plotBinsPoint(id) {
    if (this.plotBins) {
      this.plotAllKhatta(this.secondaryPointData)
    } else {
      this.removeSecPoint(id)
    }
  }

  removeSecPoint(id) {
    if (this.secPointMarker.length > 0) {
      for (var i = 0; i < this.secPointMarker.length; i++) {
        if (this.secPointMarker[i].OEMID == id) {
          this.secPointMarker[i].setVisible(false)
        }
      }
    }
  }
  // plotAllKhatta(data) {
  //     var infoWindow = new google.maps.InfoWindow();
  //     var bounds = new google.maps.LatLngBounds();
  //     var coordinates = [];
  //     var markers = [];
  //     var totalCount = 0;
  //     var totalDuration = 0;
  //     var icon = 'assets/img/khatta.png';
  //     for (var i = 0; i < data.length; i++) {
  //         var item = data[i];
  //         if (item.LAT != null && item.LNG != null) {
  //             var marker;
  //             if (item.OEMID == 40 && this.plotKhattaPoint) {
  //                 if (item.IsClosed) {
  //                     icon = 'assets/img/khattaclosed.png';
  //                 } else {
  //                     icon = 'assets/img/khatta.png';
  //                 }
  //                 marker = new google.maps.Marker({
  //                     position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
  //                     map: this.map,
  //                     icon: icon,
  //                     title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
  //                     OEMID: data[i].OEMID
  //                 });
  //                 this.secPointMarker.push(marker);
  //                 marker.setMap(this.map);
  //             } else if (item.OEMID == 14 && this.plotBins) {
  //                 icon = 'assets/img/dustbin.png';
  //                 marker = new google.maps.Marker({
  //                     position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
  //                     map: this.map,
  //                     icon: icon,
  //                     title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
  //                     OEMID: data[i].OEMID
  //                 });
  //                 this.secPointMarker.push(marker);
  //                 marker.setMap(this.map);
  //             }
  //             else if (item.OEMID == 12 && this.plotFCTS) {
  //                 icon = 'assets/img/ts.png';
  //                 marker = new google.maps.Marker({
  //                     position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
  //                     map: this.map,
  //                     icon: icon,
  //                     title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
  //                     OEMID: data[i].OEMID
  //                 });
  //                 this.secPointMarker.push(marker);
  //                 marker.setMap(this.map);
  //             }
  //             else if (item.OEMID == 15 && this.plotPlant) {
  //                 icon = 'assets/img/plant.png';
  //                 marker = new google.maps.Marker({
  //                     position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
  //                     map: this.map,
  //                     icon: icon,
  //                     title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
  //                     OEMID: data[i].OEMID
  //                 });
  //                 this.secPointMarker.push(marker);
  //                 marker.setMap(this.map);
  //             }
  //             else if (item.OEMID == 11 && this.plotPCTS) {
  //                 icon = 'assets/img/pcts.png';
  //                 marker = new google.maps.Marker({
  //                     position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
  //                     map: this.map,
  //                     icon: icon,
  //                     title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
  //                     OEMID: data[i].OEMID
  //                 });
  //                 this.secPointMarker.push(marker);
  //                 marker.setMap(this.map);
  //             } else if (item.OEMID == 13 && this.plotParking) {
  //                 icon = 'assets/img/parking.png';
  //                 marker = new google.maps.Marker({
  //                     position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
  //                     map: this.map,
  //                     icon: icon,
  //                     title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
  //                     OEMID: data[i].OEMID
  //                 });
  //                 this.secPointMarker.push(marker);
  //                 marker.setMap(this.map);
  //             } else if (item.OEMID == 42 && this.plotMTS) {
  //                 icon = 'assets/img/mts.png';
  //                 marker = new google.maps.Marker({
  //                     position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
  //                     map: this.map,
  //                     icon: icon,
  //                     title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
  //                     OEMID: data[i].OEMID
  //                 });
  //                 this.secPointMarker.push(marker);
  //                 marker.setMap(this.map);
  //             }
  //             if (item) {

  //                 marker.OEMNAME = item.OEMNAME;
  //                 marker.LAT = item.LAT;
  //                 marker.LNG = item.LNG
  //                 marker.ENTITYNAME = item.ENTITYNAME
  //                 markers.push(marker)
  //             }

  //         }
  //         (function (marker, data, thisRef) {
  //             var position = { lat: marker.LAT, lng: marker.LNG }
  //             google.maps.event.addListener(marker, "click", function (e) {
  //                 thisRef.http.post(environment.apiUrl + "entity/getEntityByPoint", position).subscribe(data => {
  //                     var entity = data[0]
  //                     var content = "<div class='col-sm-12 '>" + "<p class='info-deatil'><strong>Name:</strong>" + "  " + marker.ENTITYNAME +
  //                         "</p><p class='info-deatil'><strong>Type</strong>" + "  " + marker.OEMNAME +
  //                         "</p><p class='info-deatil'><strong>Position</strong>" + "  " + marker.LAT + "," + marker.LNG +
  //                         "</p><p class='info-deatil'><strong>Zone</strong>" + "  " + entity.zoneName +
  //                         "</p><p class='info-deatil'><strong>Ward</strong>" + "  " + entity.WardName +

  //                         "</div>"
  //                     var infoWindow = new google.maps.InfoWindow;
  //                     infoWindow.setContent(content);
  //                     infoWindow.open(this.map, marker);
  //                 })
  //             });
  //         })(marker, item, this);
  //     }
  // }

  plotAllKhatta(data) {
    var markers = []
    var icon = 'assets/img/khatta.png'
    var marker
    for (var i = 0; i < data.length; i++) {
      var item = data[i]
      if (item.LAT != null && item.LNG != null) {
        if (item.OEMID == 40 && this.plotKhattaPoint && item.IsClosed != 1) {
          icon = 'assets/img/khatta.png'
          marker = new google.maps.Marker({
            position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
            map: this.map,
            icon: icon,
            title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
            OEMID: data[i].OEMID,
          })
          this.secPointMarker.push(marker)
          marker.setMap(this.map)
        } else if (
          item.OEMID == 40 &&
          this.plotClosedKhattaPoint &&
          item.IsClosed
        ) {
          icon = 'assets/img/khattaclosed.png'
          marker = new google.maps.Marker({
            position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
            map: this.map,
            icon: icon,
            title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
            OEMID: data[i].OEMID,
          })
          this.secPointMarker.push(marker)
          marker.setMap(this.map)
        } else if (item.OEMID == 14 && this.plotBins) {
          icon = 'assets/img/dustbin.png'
          marker = new google.maps.Marker({
            position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
            map: this.map,
            icon: icon,
            title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
            OEMID: data[i].OEMID,
          })
          this.secPointMarker.push(marker)
          marker.setMap(this.map)
        } else if (item.OEMID == 12 && this.plotFCTS) {
          icon = 'assets/img/ts.png'
          marker = new google.maps.Marker({
            position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
            map: this.map,
            icon: icon,
            title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
            OEMID: data[i].OEMID,
          })
          this.secPointMarker.push(marker)
          marker.setMap(this.map)
        } else if (item.OEMID == 13 && this.plotParking) {
          icon = 'assets/img/parking.png'
          marker = new google.maps.Marker({
            position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
            map: this.map,
            icon: icon,
            title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
            OEMID: data[i].OEMID,
          })
          this.secPointMarker.push(marker)
          marker.setMap(this.map)
        } else if (item.OEMID == 11 && this.plotPCTS) {
          icon = 'assets/img/pcts.png'
          marker = new google.maps.Marker({
            position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
            map: this.map,
            icon: icon,
            title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
            OEMID: data[i].OEMID,
          })
          this.secPointMarker.push(marker)
          marker.setMap(this.map)
        } else if (item.OEMID == 15 && this.plotPlant) {
          icon = 'assets/img/plant.png'
          marker = new google.maps.Marker({
            position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
            map: this.map,
            icon: icon,
            title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
            OEMID: data[i].OEMID,
          })
          this.secPointMarker.push(marker)
        } else if (item.OEMID == 42 && this.plotMTS) {
          icon = 'assets/img/mts.png'
          marker = new google.maps.Marker({
            position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
            map: this.map,
            icon: icon,
            title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
            OEMID: data[i].OEMID,
          })
          this.secPointMarker.push(marker)
          marker.setMap(this.map)
        } else {
          icon = 'assets/img/ms.png'
          marker = new google.maps.Marker({
            position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LNG) },
            map: this.map,
            icon: icon,
            title: data[i].ENTITYNAME + ' ( ' + data[i].OEMNAME + ' ) ',
            OEMID: data[i].OEMID,
          })
          this.secPointMarker.push(marker)
          marker.setMap(this.map)
        }
        if (item) {
          marker.OEMNAME = item.OEMNAME
          marker.LAT = item.LAT
          marker.LNG = item.LNG
          marker.ENTITYNAME = item.ENTITYNAME
          markers.push(marker)
        }
      }
      ;(function (marker, data, thisRef) {
        var position = { lat: marker.LAT, lng: marker.LNG }
        google.maps.event.addListener(marker, 'click', function (e) {
          thisRef.http
            .post(environment.apiUrl + 'entity/getEntityByPoint', position)
            .subscribe((data) => {
              var entity = data[0]
              var content =
                "<div class='col-sm-12 '>" +
                "<p class='info-deatil'><strong>Name:</strong>" +
                '  ' +
                marker.ENTITYNAME +
                "</p><p class='info-deatil'><strong>Type</strong>" +
                '  ' +
                marker.OEMNAME +
                "</p><p class='info-deatil'><strong>Position</strong>" +
                '  ' +
                marker.LAT +
                ',' +
                marker.LNG +
                "</p><p class='info-deatil'><strong>Zone</strong>" +
                '  ' +
                entity.zoneName +
                "</p><p class='info-deatil'><strong>Ward</strong>" +
                '  ' +
                entity.WardName +
                '</div>'
              var infoWindow = new google.maps.InfoWindow()
              infoWindow.setContent(content)
              infoWindow.open(this.map, marker)
            })
        })
      })(marker, item, this)
    }
  }

  plotEngineOffLocation(engineOffData) {
    //this.clearStopMarker()
    var data = { features: [], type: '' }
    data.type = 'FeatureCollection'
    var coordinates = []
    var stop = 0
    var totalDuration = 0
    for (var i = 0; i < engineOffData.length; i++) {
      if (engineOffData[i].LONG && engineOffData[i].LAT) {
        stop++
        var geometry = { coordinates: [], type: '' }
        geometry.coordinates.push(
          Number(engineOffData[i].LONG),
          Number(engineOffData[i].LAT),
        )
        geometry.type = 'Point'
        // var duration =  this.diff_hours(new Date(engineOffData[i].STARTTIME), new Date(engineOffData[i].ENDTIME))
        totalDuration = totalDuration + engineOffData[i].duration
        data.features.push({
          geometry: geometry,
          type: 'Feature',
          properties: {
            ZONE: engineOffData[i].zoneName,
            WARD: engineOffData[i].WardName,
            TYPE: 'engine_Off',
            STARTTIME: engineOffData[i].HEARTBEATDATE,
          },
        })
      }
    }
    this.map.data.addGeoJson(data)
  }
  drivingSummaryModal() {
    $('#drivingSummary').modal('show')
  }

  diff_hours(dt2, dt1) {
    var difference = dt1.getTime() - dt2.getTime() // This will give difference in milliseconds
    var resultInMinutes = Math.round(difference / 60000)
    var hours = resultInMinutes / 60
    var rhours = Math.floor(hours)
    var minutes = (hours - rhours) * 60
    var rminutes = Math.round(minutes)
    return rhours + ': ' + rminutes
  }

  diff_minutes(dt2, dt1) {
    var difference = dt1.getTime() - dt2.getTime() // This will give difference in milliseconds
    var resultInMinutes = Math.round(difference / 60000)
    var hours = resultInMinutes / 60
    var rhours = Math.floor(hours)
    var minutes = (hours - rhours) * 60
    var rminutes = Math.round(minutes)
    return rminutes
  }

  plotStopPosition(stopInfo) {
    this.clearStopMarker()
    var data = { features: [], type: '' }
    data.type = 'FeatureCollection'
    var coordinates = []
    var stop = 0
    var totalDuration = 0
    for (var i = 0; i < stopInfo.length; i++) {
      if (stopInfo[i].LONG && stopInfo[i].LAT) {
        stop++
        var geometry = { coordinates: [], type: '' }
        geometry.coordinates.push(
          Number(stopInfo[i].LONG),
          Number(stopInfo[i].LAT),
        )
        geometry.type = 'Point'
        var duration = this.diff_hours(
          new Date(stopInfo[i].STARTTIME),
          new Date(stopInfo[i].ENDTIME),
        )
        // #needcheck
        var difInMinutes = this.diff_minutes(
          new Date(stopInfo[i].STARTTIME),
          new Date(stopInfo[i].ENDTIME),
        )

        totalDuration = totalDuration + stopInfo[i].duration
        data.features.push({
          geometry: geometry,
          type: 'Feature',
          properties: {
            DEVICEID: stopInfo[i].DEVICEID,
            VEHICLE_NO: stopInfo[i].VEHICLE_NO,
            STARTTIME: stopInfo[i].STARTTIME,
            ENDTIME: stopInfo[i].ENDTIME,
            DURATION: duration,
            difInMinutes: difInMinutes,
            ZONE: stopInfo[i].zoneName,
            WARD: stopInfo[i].WardName,
            BEAT: stopInfo[i].beatName,
            TYPE: 'stopMarker',
            engineStatus: stopInfo[i].ACC == 0 ? 'Off' : 'On',
            number: stop,
          },
        })
      }
    }
    this.totalStop = stop
    var hours = totalDuration / 60
    var rhours = Math.floor(hours)
    var minutes = (hours - rhours) * 60
    var rminutes = Math.round(minutes)
    this.totalDuration = rhours + ': ' + rminutes + '(hh:mm)'
    this.map.data.addGeoJson(data)

    if (this.totalStop == 0) {
      this.cover = 0
    } else {
      var cal = (this.totalStop * 10) / 100

      this.cover = cal + this.totalStop

      if (this.cover > 100) {
        var cal = (this.totalStop * 80) / 100
        this.cover = this.totalStop - cal
      }

      //console.log(this.cover);
    }
  }

  makeRoute(polyCords) {
    this.routePath = polyCords
    var lineSymbol = {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      fillColor: '#121C11',
      offset: '2%',
    }
    this.route = new google.maps.Polyline({
      path: polyCords,
      strokeColor: '#121C11',
      strokeOpacity: 3.0,
      strokeWeight: 3,
      icons: [
        {
          icon: lineSymbol,
          offset: '100%',
        },
      ],
      map: this.map,
    })
  }
  createRouteChunk(coordinates) {
    this.multiRoute = []
    var lineSymbol = {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      fillColor: '#D8E20F',
      offset: '2%',
    }
    var chunk_size = 10
    var coords = []
    var arrayLength = coordinates.length
    for (var index = 0; index < arrayLength; index += chunk_size) {
      var myChunk = coordinates.slice(index, index + chunk_size)
      for (var i = 0; i < myChunk.length; i++) {
        coords.push({ lat: myChunk[i].LAT, lng: myChunk[i].LONG })
      }

      var route = new google.maps.Polyline({
        path: coords,
        strokeColor: '#121C11',
        strokeOpacity: 3.0,
        strokeWeight: 3,
        icons: [
          {
            icon: lineSymbol,
            offset: '100%',
          },
        ],
        map: this.map,
      })

      this.multiRoute.push(route)

      //this.makeRoute(coords);
      coords = []
    }
    this.plotMultiRoute()
  }

  plotMultiRoute() {
    for (var i = 0; i < this.multiRoute.length; i++) {
      this.multiRoute[i].setMap(true)
    }
  }

  removeMultiRoute() {
    if (this.multiRoute.length > 0) {
      for (var i = 0; i < this.multiRoute.length; i++) {
        this.multiRoute[i].setMap(null)
      }
    }
  }

  plotRouteWhenLiveTrack() {
    this.route = new google.maps.Polyline({
      path: this.routePath,
      strokeColor: '#686C55',
      strokeOpacity: 1.0,
      strokeWeight: 3,
      map: this.map,
    })
  }
  createRoute(map, pathCoords) {
    var i, route, marker
    var polyCords = []
    for (i = 0; i < pathCoords.length; i++) {
      polyCords.push({
        lat: JSON.parse(pathCoords[i][1]),
        lng: JSON.parse(pathCoords[i][0]),
      })
    }
    var car =
      'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
    var icon = {
      path: car,
      scale: 1,
      strokeColor: 'white',
      strokeWeight: 0.1,
      fillOpacity: 5,
      fillColor: '#35370C',
      offset: '2%',
      // rotation: parseInt(heading[i]),
      anchor: new google.maps.Point(10, 25), // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
    }

    //console.log('3122',polyCords);

    this.routePath = polyCords
    this.route = new google.maps.Polyline({
      path: polyCords,
      strokeColor: '#E2EF16',
      strokeOpacity: 4.0,
      strokeWeight: 5,
      icons: [
        {
          icon: icon,
          offset: '100%',
        },
      ],
      map: map,
    })

    this.zoomToObject(this.route)
  }

  clearCurrentVehicalInfo() {
    this.distance = null
    this.vehiclesNo = null
    this.lastActiveTime = null
    this.totalStop = null
    this.totalDuration = null
    this.servingWardName = null
    this.assignWard = null
    this.currentAddressStart = null
    this.IMEI = null
    this.vehiclesType = null
    this.startTime = null
    this.endTime = null
    this.currentAddress = null
  }
  vehiclelist() {
    $('.individual_box').show()
    $('#vehicleList').show()
    $('.vehiclelistbox').show()
  }
  closeVehicle() {
    $('.vehiclelistbox').slideToggle()
    $('.fa-chevron-left').toggleClass('fa-chevron-right')
  }
  showCurrentVehiclesInfo(data, tableRow) {
    this.beatName = data.END_BEATNAME
    this.distance = data.distance.toFixed(2)
    this.vehiclesNo = tableRow.vehno
    this.IMEI = tableRow.IMEI
    this.vehiclesType = tableRow.vehtypname
    this.startTime = moment(new Date(data.STARTTIME)).format('h:mm:ss a')
    this.endTime = moment(new Date(data.ENDTIME)).format('h:mm:ss a')
    this.lastActiveTime = tableRow.HEARTBEATDATE
    var latlng = { lat: data.ENDPOINT.LAT, lng: data.ENDPOINT.LONG }
    this.geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === 'OK') {
        this.currentAddress = results[0].formatted_address
      }
    })

    var latlngStart = { lat: data.STARTPOINT.LAT, lng: data.STARTPOINT.LONG }

    this.geocoder.geocode({ location: latlngStart }, (results, status) => {
      if (status === 'OK') {
        this.currentAddressStart = results[0].formatted_address
      }
    })
  }
  removeLine() {
    if (this.route) {
      this.route.setMap(null)
    }
  }
  removeMarker() {
    if (this.markerStart && this.markerEnd) {
      this.markerStart.setMap(null)
      this.markerEnd.setMap(null)
    } else if (this.markerStart) {
      this.markerStart.setMap(null)
    }
  }

  removeClickedMarker() {
    if (this.clickedMarker) {
      this.clickedMarker.setMap(null)
    }
  }
  removeStartAndEndPoint() {
    this.infoWindowStart.close()
    this.infoWindowEnd.close()
  }
  StatusUp() {
    $('.status_extra').slideToggle()
    $('.fa-chevron-down').toggleClass('fa-chevron-up')
  }

  plotStartAndEndPoint(data) {
    var start = new google.maps.LatLng(
      data.STARTPOINT.LAT,
      data.STARTPOINT.LONG,
    )
    var end = new google.maps.LatLng(data.ENDPOINT.LAT, data.ENDPOINT.LONG)
    this.markerStart = new google.maps.Marker({
      position: start,
      map: this.map,
      icon: 'assets/img/start.png',

      labelClass: 'labels', // the CSS class for the label
      labelStyle: { opacity: 1.0 },
    })
    this.markerEnd = new google.maps.Marker({
      position: end,
      map: this.map,
      icon: 'assets/img/end.png',
    })
  }

  autoRefreshLiveData(map, pathCoords, id) {
    var i, route, marker
    var polyCords = []
    var polyLiveCords = []
    this.removePolyLine(id)
    for (i = 0; i < pathCoords.length; i++) {
      polyCords.push({
        lat: JSON.parse(pathCoords[i][1]),
        lng: JSON.parse(pathCoords[i][0]),
      })
      //  this.routePath.push({ lat: JSON.parse(pathCoords[i][1]), lng: JSON.parse(pathCoords[i][0]) })
    }
    // if(this.live){
    //   this.plotLiveRoute(pathCoords)
    // }

    this.Liveroute = new google.maps.Polyline({
      path: polyCords,
      strokeColor: '#686C55',
      strokeOpacity: 1.0,
      strokeWeight: 4,
      icons: [
        {
          icon: this.icon,
          offset: '100%',
        },
      ],
      map: this.map,
    })
    this.polyline_array.push({ line: this.Liveroute, id: id })
    // this.animateCircle(this.Liveroute)
    var markerPoint = pathCoords[0]
    polyCords = []
  }

  plotLiveRoute(polyCords) {
    this.route = new google.maps.Polyline({
      path: polyCords,
      strokeColor: '#686C55',
      strokeOpacity: 1.0,
      strokeWeight: 4,
      icons: [
        {
          icon: this.icon,
          offset: '100%',
        },
      ],
      map: this.map,
    })
  }
  removePolyLine(id) {
    for (var i = 0; i < this.polyline_array.length; i++) {
      if (id == this.polyline_array[i].id) {
        this.polyline_array[i].line.setMap(null)
      }
    }
  }

  animateLiveCircle(line) {
    var count = 0
    var value = 300
    stopAnimation = true
    var myinterval = setInterval(() => {
      count = (count + 1) % 200
      var icons = line.get('icons')
      icons[0].offset = count / 2 + '%'
      if (count === 199) {
        line.set('icons', null)
        clearInterval(myinterval)
        //line.unSet('icons', icons);
        line.setMap(null)
      }
      line.set('icons', icons)
    }, 250)
  }

  animateCircle(line) {
    var count = 0
    // $('#play').hide();
    // $('#stop').show();
    this.stopBtn = true
    if (!stopAnimation) {
      stopAnimation = true
      return
    }
    stopAnimation = true
    var myVar = window.setInterval(function () {
      if (stopAnimation) {
        count = (count + 1) % 200
        var icons = line.get('icons')
        icons[0].offset = count / 2 + '%'
        if (count === 199) {
          clearInterval(myVar)
          $('#play').show()
          $('#stop').hide()
        }
        line.set('icons', icons)
      }
    }, 150)
  }

  async refreshLiveData() {
    let vehicles = await fetch(
      environment.apiUrl + 'vehicles/location/all' + '?prjID=' + this.prjID,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.vehiclesLocation = await vehicles.json()
    this.plotAllVehicles(this.vehiclesLocation)
  }
  stopPlay() {
    this.stopBtn = false
    stopAnimation = false
    // $('#play').show();
    // $('#stop').hide();
  }
  zoomToObject(obj) {
    var bounds = new google.maps.LatLngBounds()
    var points = obj.getPath().getArray()
    for (var n = 0; n < points.length; n++) {
      bounds.extend(points[n])
    }
    this.map.fitBounds(bounds)
  }

  clearFeature() {
    this.map.data.forEach((feature) => {
      this.map.data.remove(feature)
    })
  }
  removeMapLabel(entityId) {
    for (var i = 0; i < this.mapLabelArray.length; i++) {
      if (entityId == this.mapLabelArray[i].entityId) {
        this.mapLabelArray[i].setMap(null)
      }
    }
  }

  async plotRouteBoundary(entityId) {
    this.loaderService.display(true)
    if (!this.routeBoundary) {
      this.map.data.forEach((feature) => {
        if (feature.getProperty('Oemid') == entityId) {
          this.map.data.remove(feature)
        }
      })
      this.loaderService.display(false)
    } else {
      if (this.routePolygondData) {
        this.map.data.addGeoJson(this.routePolygondData.geoJson)

        var currentdata = ''
        this.map.data.addListener('mouseover', function (event) {
          var position = { lat: event.latLng.lat(), lng: event.latLng.lng() }
          var infoWindow = new google.maps.InfoWindow()
          infoWindow.close(this.map)
          var content =
            "<div class='col-sm-12'>" +
            "<p class='info-deatil'><strong>Entry ID :</strong>" +
            '  ' +
            event.feature.getProperty('mainId') +
            "</p><p class='info-deatil'><strong>Name :</strong>" +
            '  ' +
            event.feature.getProperty('title')

          '</p></div>'
          infoWindow = new google.maps.InfoWindow({
            content: content,
            position: position,
          })

          google.maps.InfoWindowOptions
          this.selectedLineDetails = event.feature.getProperty('mainId')
        })

        this.loaderService.display(false)
      } else {
        alert(
          'Please wait while the data is being fetched. This may take upto one minute. Thank You!',
        )
        this.routeBoundary = false
        this.loaderService.display(false)
      }
    }
  }

  async plotBeatBoundary(entityId) {
    this.loaderService.display(true)
    if (!this.beatBoundary) {
      this.map.data.forEach((feature) => {
        if (
          feature.getProperty('TYPE') != 'stopMarker' &&
          feature.getProperty('Oemid') == entityId
        ) {
          this.map.data.remove(feature)
        }
      })
      this.loaderService.display(false)
    } else {
      this.map.data.addGeoJson(this.beatPolygondData.geoJson)
      this.loaderService.display(false)
    }
  }

  async plotWardBoundary(entityId) {
    // this.wardBoundary = this.wardBoundary ? false : true
    this.loaderService.display(true)
    if (!this.wardBoundary) {
      this.map.data.forEach((feature) => {
        if (
          feature.getProperty('TYPE') != 'stopMarker' &&
          feature.getProperty('Oemid') == entityId
        ) {
          this.map.data.remove(feature)
          this.removeMapLabel(feature.getProperty('EntityID'))
        }
      })
      this.loaderService.display(false)
    } else {
      this.map.data.addGeoJson(this.wardPolygondData.geoJson)
      this.loaderService.display(false)
    }
  }

  // async getWardPolygon() {
  //     let polygon = await fetch(environment.apiUrl + 'entity/getPolygonByOemId' + '?prjid=' + this.prjID + '&wardOemId=' + 8 + '&beatOemId =' + null,
  //         {
  //             method: 'get',
  //             headers: {
  //                 Accept: 'application/json',
  //                 'Content-Type': 'application/json',
  //                 Authorization: this.authtoken.token
  //             }
  //         }
  //     );
  //     var polygondData = await polygon.json();
  //     this.wardPolygonList = polygondData.entityData;

  // }

  // selectWard(polygonData) {

  //     var data = {
  //         features: [{ geometry: {}, type: 'Feature', properties: '' }],
  //         type: ''
  //     };
  //     var d = JSON.parse(polygonData.kml);
  //     data.features[0].geometry = d;
  //     var prop = JSON.parse(polygonData.properties);
  //     prop.type = 'clickedPolygon';
  //     data.features[0].properties = prop;
  //     data.type = 'FeatureCollection';
  //     var color = '#B05C3C';
  //     this.map.data.forEach((feature) => {
  //         if (feature.getProperty('type') == 'clickedPolygon') {
  //             this.map.data.remove(feature);
  //         }
  //     });
  //     this.removeOutsideMarker(polygonData.entityname);
  //     this.map.data.addGeoJson(data);
  //     this.zoomOneEntity(this.map);
  // }

  // removeOutsideMarker(entityName) {
  //     this.vehicleInWard = [];
  //     if (this.allMarkers.length > 0) {
  //         for (var i = 0; i < this.allMarkers.length; i++) {
  //             if (entityName == this.allMarkers[i].WARD || entityName == this.allMarkers[i].ZONE) {
  //                 this.allMarkers[i].setVisible(true);
  //                 var obj = {
  //                     IMEI: this.allMarkers[i].id,
  //                     VEHICLE_NO: this.allMarkers[i].vehno,
  //                     DATETIME: this.allMarkers[i].dateTime,
  //                     'DISTANCE(KM)': this.allMarkers[i].DISTANCE,
  //                     WARD: this.allMarkers[i].WARD,
  //                     BEAT: this.allMarkers[i].BEAT,
  //                     TYPE: this.allMarkers[i].VTYPE
  //                 };
  //                 this.vehicleInWard.push(obj);
  //             } else {
  //                 this.allMarkers[i].setVisible(false);
  //             }
  //         }
  //     }
  // }

  // vehicleInWardExport() {
  //     const ws_name = 'SomeSheet';
  //     const wb: WorkBook = { SheetNames: [], Sheets: {} };
  //     const ws: any = utils.json_to_sheet(this.vehicleInWard);
  //     wb.SheetNames.push(ws_name);
  //     wb.Sheets[ws_name] = ws;
  //     const wbout = write(wb, {
  //         bookType: 'xlsx',
  //         bookSST: true,
  //         type: 'binary'
  //     });
  //     saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'Vehicle.xlsx');
  // }

  clearPrevRoute(data) {
    this.map.data.forEach((feature) => {
      if (feature.getProperty('type') == 'route') {
        this.map.data.remove(feature)
      }
    })
  }

  clearStopMarker() {
    this.map.data.forEach((feature) => {
      if (
        feature.getProperty('TYPE') == 'stopMarker' ||
        feature.getProperty('TYPE') == 'engine_Off'
      ) {
        this.map.data.remove(feature)
      }
    })
  }

  highLightAssignBeat(entityId) {
    this.map.data.setStyle(function (feature) {
      var color = feature.getProperty('FillColor')
      var strokeColor = feature.getProperty('Bcolor')
      if (feature.getProperty('EntityID') == entityId) {
        return {
          fillColor: '#3E0560',
          strokeColor: '#3E0560',
          strokeWeight: 2,
          fillOpacity: 0.5,
          strokeopacity: 0.4,
        }
      } else if (feature.getProperty('TYPE') == 'stopMarker') {
        if (feature.getProperty('difInMinutes') > 20) {
          var icon = 'assets/img/delayStop.png'
        } else {
          var icon = 'assets/img/stopMarker.png'
        }
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 2,
          fillOpacity: 0.05,
          icon: icon,
          strokeopacity: 0.2,
          label: {
            text: feature.getProperty('number'),
            color: '#FFFFFF',
            fontSize: '13px',
            background: 'yellow',
            fontWeight: 'bold',
            AlignmentVertical: 'top',
            AlignmentHorizontal: 'center',
          },
          labelClass: 'my-custom-class-for-label',
        }
      } else if (feature.getProperty('TYPE') == 'khatta') {
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 5,
          fillOpacity: 0.0,
          strokeopacity: 0.2,
          icon: 'assets/img/khatta.png',
        }
      } else if (
        feature.getProperty('Oemid') == 8 ||
        feature.getProperty('Oemid') == 9 ||
        feature.getProperty('Oemid') == 10 ||
        feature.getProperty('Oemid') == undefined
      ) {
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 3,
          fillOpacity: 0.1,
          strokeopacity: 0.8,
        }
      } else {
        return {
          fillColor: color,
          strokeColor: '#040C0A',
          strokeWeight: 4,
          fillOpacity: 0.1,
          strokeopacity: 0.4,
        }
      }
    })
  }

  setStyle(thisRef) {
    this.map.data.setStyle(function (feature) {
      var color = feature.getProperty('FillColor')
      var strokeColor = feature.getProperty('Bcolor')
      var strokeOpacity = feature.getProperty('stroke-opacity')
      if (feature.getProperty('Oemid') == 8) {
        thisRef.polygonLabel(
          feature.getProperty('Ward'),
          feature.getProperty('LAT'),
          feature.getProperty('LON'),
          16,
          12,
          feature.getProperty('EntityID'),
          strokeColor,
        )
      } else if (feature.getProperty('Oemid') == 7) {
        thisRef.polygonLabel(
          feature.getProperty('Zone'),
          feature.getProperty('LAT'),
          feature.getProperty('LON'),
          18,
          13,
          feature.getProperty('EntityID'),
          '#010100',
        )
      }
      // else if(feature.getProperty('Oemid') == 9){
      //   thisRef.polygonLabel(feature.getProperty('Beat'),feature.getProperty('LAT'),feature.getProperty('LON'))
      // }

      if (feature.getProperty('TYPE') == 'stopMarker') {
        if (feature.getProperty('difInMinutes') > 20) {
          var icon = 'assets/img/delayStop.png'
        } else {
          var icon = 'assets/img/stopMarker.png'
        }
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 2,
          fillOpacity: 0.05,
          icon: icon,
          strokeopacity: 0.2,
          label: {
            text: feature.getProperty('number'),
            color: '#FFFFFF',
            fontSize: '13px',
            background: 'yellow',
            fontWeight: 'bold',
            AlignmentVertical: 'top',
            AlignmentHorizontal: 'center',
          },
          labelClass: 'my-custom-class-for-label',
        }
      } else if (feature.getProperty('TYPE') == 'khatta') {
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 5,
          fillOpacity: 0.0,
          strokeopacity: 0.2,
          icon: 'assets/img/khatta.png',
        }
      } else if (
        feature.getProperty('Oemid') == 8 ||
        feature.getProperty('Oemid') == 9 ||
        feature.getProperty('Oemid') == 10 ||
        feature.getProperty('Oemid') == undefined
      ) {
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 3,
          fillOpacity: 0.1,
          strokeopacity: 0.8,
        }
      } else {
        return {
          fillColor: color,
          strokeColor: '#040C0A',
          strokeWeight: 4,
          fillOpacity: 0.1,
          strokeopacity: 0.4,
        }
      }
    })
  }

  /* 
     excel Import
  */

  s2ab(s) {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff
    }
    return buf
  }
  importToExcel(data, filename) {
    const ws_name = 'SomeSheet'
    const wb: WorkBook = { SheetNames: [], Sheets: {} }
    const ws: any = utils.json_to_sheet(data)
    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary',
    })
    this.disabeDownloadBtn = false
    saveAs(
      new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      filename + '.xlsx',
    )
  }

  fixDate() {
    // let date = moment(new Date()).format("YYYY-MM-DD")
    // let selectedDate = moment(this.date).format("YYYY-MM-DD")
    // this.currentDate = (selectedDate == date) ? true : false

    // this.downloadReportDate = selectedDate;

    // let date = moment(new Date()).format("YYYY-MM-DD")
    // let selectedDate = moment(this.date).format("YYYY-MM-DD")
    this.currentDate = true

    // this.downloadReportDate = selectedDate;

    if (!this.currentDate) {
      $('.liveStatus').hide()
      $('#progressBar').hide()
    } else {
      $('.liveStatus').show()
      $('#progressBar').show()
    }

    // this.vehiclesData =
  }

  async refreshCount(id) {
    //git this.renoveAllMarker()
    let d = await fetch(
      environment.apiUrl +
        'vehicles/getAll?currentUserID=' +
        this.userId +
        '&prjId=' +
        this.prjID +
        '&date=' +
        //moment(this.date).format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.tempVehiclesData = await d.json()
    this.notInDb = this.tempVehiclesData.notInDb
    this.totalNotInDb = this.tempVehiclesData.notInDb.length
    this.applyFilter(this.tempVehiclesData.liveData)
    this.getCount(this.vehiclesData)
    // this.plotAllVehicles(this.vehiclesData)
    this.clearPrevCount()
  }

  runProgressBar() {
    var bar = document.getElementById('progressBar')
    var barWidth = 0
    var identity = setInterval(() => {
      if (barWidth >= 100) {
        clearInterval(identity)
      } else {
        barWidth++
        bar.style.width = barWidth + '%'
        // bar.style.transition = 'all 0.3s';
      }
    }, 90)
  }
  /*

      dead report

  */
  ViewDaedReportbtn() {
    $('#ViewDaedReportModal').modal('show')
    this.getDeadReport()
    this.selectedDeadList = 'notRunningSince15Days'
  }
  getDeadArray(data, selected) {
    this.deadVehicleList = data
    this.selectedDeadList = selected
  }
  async getDeadReport() {
    let vehicles = await fetch(
      environment.apiUrl + 'vehicles/deadVehicleReport?prjId=' + this.prjID,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    this.deadVehicleSummary = await vehicles.json()
    this.notRunningSince15Days = this.deadVehicleSummary.notRunningSince15Days.count
    this.notRunningSince10Days = this.deadVehicleSummary.notRunningSince10Days.count
    this.notRunningSince5Days = this.deadVehicleSummary.notRunningSince5Days.count
    this.notRunningSince2Days = this.deadVehicleSummary.notRunningSince2Days.count

    this.notRunningSince15DaysArray = this.deadVehicleSummary.notRunningSince15Days.data
    this.notRunningSince10DaysArray = this.deadVehicleSummary.notRunningSince10Days.data
    this.notRunningSince5DaysArray = this.deadVehicleSummary.notRunningSince5Days.data
    this.notRunningSince2DaysArray = this.deadVehicleSummary.notRunningSince2Days.data

    this.deadVehicleList = this.notRunningSince15DaysArray
  }

  importDeadList(data) {
    for (var i = 0; i < data.length; i++) {
      delete data[i].isactive
      delete data[i].id
      delete data[i].sim
      delete data[i].vehtypid
      delete data[i].vehTempNo
    }
    const ws_name = 'SomeSheet'
    const wb: WorkBook = { SheetNames: [], Sheets: {} }
    const ws: any = utils.json_to_sheet(data)
    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary',
    })
    saveAs(
      new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      'notrunning.xlsx',
    )
  }

  getVehicleType() {
    this.http
      .get(
        environment.apiUrl +
          'vehicles/runningVehicleByType?prjId=' +
          this.prjID,
      )
      .subscribe((data) => {
        var result: any
        result = data
        var totalAvilable = 0
        var totalWorking = 0
        for (var i = 0; i < result.length; i++) {
          totalWorking = totalWorking + result[i].active
          totalAvilable = totalAvilable + result[i].total
        }
        this.totalWorking = totalWorking
        this.totalAvilable = totalAvilable
        this.runningVehiclesByType = data

        //  if (this.runningVehiclesByType.length) {
        this.vehicleStatControl()
        // }
      })
  }

  locateVehicle(position) {
    var myPlace = new google.maps.LatLng(position.LAT, position.LONG)
    var bounds = new google.maps.LatLngBounds(myPlace)
    this.map.fitBounds(bounds)
  }

  viewStats() {
    if (this.runningVehiclesByType.length == 0) {
      this.getVehicleType()
    }

    $('#divwastedate').slideToggle()
    $('#divvehicledate').slideToggle()

    if (this.isStats == false) {
      this.isStats = true
      $('#divvehicledate').hide()
    } else {
      this.isStats = false
      $('#divvehicledate').show()
    }
  }
  runningVehicleByType() {
    // Set CSS for the control border.
    var thisRef = this
    var controlDiv = document.createElement('div')
    var controlUI = document.createElement('div')
    controlUI.style.backgroundColor = '#fff'
    controlUI.style.border = '2px solid #fff'
    controlUI.style.borderRadius = '2px'
    controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)'
    controlUI.style.cursor = 'pointer'
    controlUI.style.margin = '10px'

    controlUI.style.textAlign = 'center'
    controlUI.title = 'STATS'
    controlDiv.appendChild(controlUI)

    // Set CSS for the control interior.
    var controlText = document.createElement('div')
    controlText.style.color = 'rgb(25,25,25)'
    //            controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
    //            controlText.style.fontSize = '13px';
    controlText.style.fontWeight = 'bold'
    controlText.style.lineHeight = '25px'

    controlText.innerHTML = 'STATS'
    controlText.className = 'gm-style-mtc'
    controlText.style.paddingLeft = '5px'
    controlText.style.paddingRight = '5px'
    controlUI.appendChild(controlText)

    controlUI.addEventListener('click', function () {
      $('#divwastedate').slideToggle()
      $('#divvehicledate').slideToggle()
      thisRef.isStats = true
      if (thisRef.isStats == false) {
        thisRef.isStats = true
        $('#divVehcile1').css('top', '-439px')
        $('#divVehcile2').css('top', '-439px')
      } else {
        thisRef.isStats = false
        $('#divVehcile1').css('top', '-140px')
        $('#divVehcile2').css('top', '-140px')
      }
    })
  }

  vehicleStatControl() {
    var htmlString =
      "<table class=\"table-bordered\"><tr><td align='center' colspan='3'><b>Vehicle Details</b></td></tr><tr><td align='left'><b>Type</b></td><td align='right'><b>Total</b></td><td align='right'><b>In Working</b></td></tr>"
    for (var i = 0; i < this.runningVehiclesByType.length; i++) {
      htmlString =
        htmlString +
        '<tr><td><b>' +
        this.runningVehiclesByType[i].type +
        "</b></td><td style='text-align:right'><b>" +
        this.runningVehiclesByType[i].total +
        "</b></td><td style='text-align:right'><b>" +
        this.runningVehiclesByType[i].active +
        '</b></td></tr> '
    }

    htmlString =
      htmlString +
      '<tr><td><b>' +
      "</b></td><td style='text-align:right'><b>" +
      this.totalAvilable +
      "</b></td><td style='text-align:right'><b>" +
      this.totalWorking +
      '</b></td></tr> '
    if (htmlString != '') {
      htmlString = htmlString + '</table>'
      $('#divvehicledate').append(htmlString)
    }
  }

  // CenterControl(controlDiv, map) {
  //     // Set CSS for the control border.
  //     var controlUI = document.createElement('table');
  //     controlUI.style.backgroundColor = '#fff';
  //     controlUI.style.border = '2px solid #fff';
  //     controlUI.style.borderRadius = '1px';
  //     controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.4)';
  //     controlUI.style.cursor = 'default';
  //     controlUI.style.marginBottom = '0px';
  //     controlUI.style.textAlign = 'top_right';
  //     controlDiv.appendChild(controlUI);

  //     // Set CSS for the control interior.
  //     this.controlText = document.createElement('div');
  //     // this.controlText.style.color = 'rgb(25,25,25)';
  //     this.controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
  //     // this.controlText.style.fontSize = '13px';
  //     // this.controlText.style.lineHeight = '15px';
  //     // this.controlText.style.paddingLeft = '3px';
  //     // this.controlText.style.marginLeft = '14px';
  //     this.controlText.style.padding = '2px';

  //     controlUI.appendChild(this.controlText);
  //     var content = [];
  //     content.push(
  //         '<span class="google-map-info" style=" text-decoration: underline; font-size:15px;">Icons Info</span><br>'
  //     );
  //     content.push(
  //         '<span (click) ="test()" class="google-map-info"> <em style="color:#D03207;font-size: 22px;margin-right: 5px;margin-left: 3px;"> X </em>  Running in diffrent ward  </span><br>'
  //     );
  //     content.push(
  //         '<span (click) ="test()" class="google-map-info"><img src="../assets/img/khatta.png"/> Khatta </span><br>'
  //     );
  //     content.push(
  //         '<span (click) ="test()" class="google-map-info"><img src="../assets/img/khattaclosed.png"/> Closed Khatta </span><br>'
  //     );
  //     content.push(
  //         '<span (click) ="test()" class="google-map-info"><img src="../assets/img/boundry_line.png" width="24"/> Boundry </span><br>'
  //     );
  //     content.push(
  //         '<span (click) ="test()" class="google-map-info"><img src="../assets/img/dustbin.png"/> Dustbin </span><br>'
  //     );
  //     content.push(
  //         '<span (click) ="test()" class="google-map-info"><img src="../assets/img/ts.png"/> FCTS </span><br>'
  //     );
  //     content.push(
  //         '<span (click) ="test()" class="google-map-info"><img src="../assets/img/mts.png"/> MTS </span><br>'
  //     );
  //     content.push(
  //         '<span (click) ="test()" class="google-map-info"><img src="../assets/img/plant.png"/> Plant </span><br>'
  //     );
  //     content.push(
  //         '<span (click) ="test()" class="google-map-info"><img src="../assets/img/stopMarker.png"/> Stop </span><br>'
  //     );
  //     content.push(
  //         '<span (click) ="test()" class="google-map-info"><img src="../assets/img/delayStop.png"/> Delayed Stop </span><br>'
  //     );
  //     content.push(
  //         '<span (click) ="test()" class="google-map-info"><img src="../assets/img/route.png"/> Route </span><br>'
  //     );
  //     content.push(
  //         '<span style="margin-bottom:5%;" (click) ="test()" class="google-map-info"><img src="../assets/img/parking.png"/> Parking </span><br>'
  //     );

  //     // content.push('<span (click) ="test()" class="google-map-info"><img src="../assets/img/hookLoader.png"/> Hook Loader </span><br>');
  //     // content.push('<span (click) ="test()" class="google-map-info"><img src="../assets/img/refuseCompactor.png"/> RC </span><br>');
  //     // content.push('<span (click) ="test()" class="google-map-info"><img src="../assets/img/tractor.png"/> Tractor </span><br>');
  //     // content.push('<span (click) ="test()" class="google-map-info"><img src="../assets/img/hyva.png"/> Hyva </span><br>');
  //     // content.push('<span (click) ="test()" class="google-map-info"><img src="../assets/img/jcb.png"/> JCB </span><br>');
  //     // content.push('<span (click) ="test()" class="google-map-info"><img src="../assets/img/triper.png"/> Tipper/Bolero </span><br>');
  //     this.controlText.innerHTML = content.join('');
  // }

  polygonLabel(text, lat, long, strokeWeight, fontSize, entityId, color) {
    var myLatlng = new google.maps.LatLng(Number(lat), Number(long))
    var mapLabel = new MapLabel({
      text: text,
      position: myLatlng,
      map: this.map,
      strokeWeight: strokeWeight,
      fontSize: fontSize,
      align: 'left',
      entityId: entityId,
      fontColor: color,
    })
    this.mapLabelArray.push(mapLabel)
    mapLabel.set('position', myLatlng)
  }

  statusColor() {
    return 'vehicle-box vts_installed_border'
  }

  closeMapInfo() {
    $('.map-info-window').hide()
  }

  startLive() {
    this.dateChanege = moment()

    this.selectedDatenew = moment(this.dateChanege).format('YYYY-MM-DD')

    this.preDate = false

    if (this.isLiveEnable) {
      this.isLiveEnable = false
    } else {
      this.isLiveEnable = true
    }

    console.log(this.isLiveEnable, 4269)
  }

  downloadReport = async () => {
    $('#loderImgTab').show()
    this.loaderService.display(true)
    this.disabeDownloadBtn = true

    if (
      moment(this.downloadReportDate).format('YYYY-MM-DD') ==
      moment().format('YYYY-MM-DD')
    ) {
      this.importToExcel(
        this.vehiclesData,
        'Vehicle Report - ' + moment().format('HHMMSS'),
      )

      return
    }

    var ownerName = ''
    var vehCat = ''
    var fuelType = ''

    if (this.filterData.ownerType.length > 0) {
      for (let i = 0; i < this.filterData.ownerType.length; i++) {
        ownerName += "'" + this.filterData.ownerType[i].name + "',"
      }
    } else {
      ownerName = "'Ecogreen','Contractor',"
    }

    if (this.filterData.vehicleCat.length > 0) {
      for (let i = 0; i < this.filterData.vehicleCat.length; i++) {
        vehCat += "'" + this.filterData.vehicleCat[i].name + "',"
      }
    } else {
      vehCat = "'Primary','Secondary',"
    }

    if (this.filterData.fuelType.length > 0) {
      for (let i = 0; i < this.filterData.fuelType.length; i++) {
        fuelType += "'" + this.filterData.fuelType[i].name + "',"
      }
    } else {
      fuelType = "'Diesel','Electric','Manual',"
    }

    let data = await fetch(
      environment.apiUrl +
        'vehicles/downloadVehicleReport' +
        '?prjId=' +
        this.prjID +
        '&date=' +
        moment(this.downloadReportDate).format('YYYY-MM-DD'),
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token,
        },
      },
    )
    var vehcileReport = await data.json()
    this.vehcileReport = vehcileReport.liveData

    this.importToExcel(
      this.vehcileReport,
      'Vehicle Report - ' + moment().format('HHMMSS'),
    )
    this.loaderService.display(false)
  }

  ngOnInit() {
    $('.map-info-window').hide()

    $('#drivingSummary').modal('hide')

    this.userId = this.auth.getAuthentication().id

    this.getFuelYypeCount()
    this.maintenanceStatus()
    this.maintenanceStatusVts()
    this.getDataWhenProjectChange(this.prjID)

    this.getAllSecondaryVehiclesOwnerNames()

    this.getForPMTime()
    // this.downloadReport();
    this.fixDate()

    if (this.prjID == 1) {
      this.isLko = true
    }

    // this.getWardPolygon();
    this.vehiclelist()
    var thisRef = this

    $('#infotable1').hide()
    $('#infotable2').hide()
    $('#statusTable').show()
    $('#play').show()
    $('#stop').hide()
    $('#veichiclesInfo-bar').hide()
    $('#progress-bar').hide()
    this.geocoder = new google.maps.Geocoder()
    var myOptions = {
      center: new google.maps.LatLng(28.47769599987369, 77.06160699973178),
      zoom: 15,

      mapTypeControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.LEFT_BOTTOM,
      },

      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },

      scaleControl: false,
      fullscreenControl: true,
      streetViewControl: false,
    }

    this.map = new google.maps.Map(document.getElementById('map'), myOptions)
    // var trafficLayer = new google.maps.TrafficLayer();
    // trafficLayer.setMap(this.map);
    var config = {
      authDomain: 'ecogreen-citizen-app.firebaseapp.com',
      apiKey: 'AIzaSyAHMkYkbjRTa9RazdKPJjtOJrdHCZVxxYg',
      databaseURL: 'HttpClient s://ecogreen-citizen-app.firebaseio.com/', //https://ecogreen-citizen-app.firebaseio.com/
      storageBucket: 'ecogreen-citizen-app.appspot.com',
      projectId: 'ecogreen-citizen-app',
    }

    var infoWindow = new google.maps.InfoWindow()
    this.map.data.addListener('click', showArrays)
    function showArrays(event) {
      if (event.feature.getProperty('TYPE') == 'stopMarker') {
        var position = { lat: event.latLng.lat(), lng: event.latLng.lng() }
        var content =
          "<div class='col-sm-12'>" +
          "<p class='info-deatil'><strong>Entry Time :</strong>" +
          '  ' +
          event.feature.getProperty('STARTTIME') +
          "</p><p class='info-deatil'><strong>Exit Time :</strong>" +
          '  ' +
          event.feature.getProperty('ENDTIME') +
          "</p><p class='info-deatil'><strong>Duration :</strong>" +
          '  ' +
          event.feature.getProperty('DURATION') +
          ' ' +
          "</p><p class='info-deatil'><strong>Ward :</strong>" +
          '  ' +
          event.feature.getProperty('WARD') +
          ' ' +
          "</p><p class='info-deatil'><strong>Engine :</strong>" +
          '  ' +
          event.feature.getProperty('engineStatus') +
          '</p></div>'
        infoWindow = new google.maps.InfoWindow({
          content: content,
          position: position,
        })

        google.maps.InfoWindowOptions
        infoWindow.open(this.map)
      } else {
        var position = { lat: event.latLng.lat(), lng: event.latLng.lng() }
        if (this.zoneWardInfoWindow) {
          this.zoneWardInfoWindow.close()
        }

        thisRef.removeClickedMarker()

        var clickedPoint = new google.maps.LatLng(
          event.latLng.lat(),
          event.latLng.lng(),
        )

        thisRef.clickedMarker = new google.maps.Marker({
          position: clickedPoint,
          map: thisRef.map,
          icon: 'assets/img/clickedMarker.png',
          labelClass: 'labels', // the CSS class for the label
          labelStyle: { opacity: 1.0 },
        })
        $('.map-info-window').show()

        $('#zoneInfo_Window').hide()
        $('#zone_loader').show()
        thisRef.http
          .post(environment.apiUrl + 'entity/getEntityByPoint', position)
          .subscribe((data) => {
            thisRef.clickedEntity = data[0]
            thisRef.geocoder.geocode(
              { location: clickedPoint },
              (results, status) => {
                if (status === 'OK') {
                  thisRef.clickedEntity.currentAddress =
                    results[0].formatted_address
                }
              },
            )
            $('#zone_loader').hide()
            $('#zoneInfo_Window').show()
          })
      }
    }

    firebase.initializeApp(config)

    var listRef = firebase.database().ref('/')

    listRef.on('child_changed', (dataSnapshot) => {
      if (this.FourTime == true) {
        return
      }

      const msg = dataSnapshot.val()

      var newPosition = dataSnapshot.val()
      var mylatlongs = new google.maps.LatLng(newPosition.LAT, newPosition.LONG)
      if (this.vechicleListIsClicked) {
        if (this.IMEI == newPosition.DEVICEID) {
          if (
            newPosition.LAT &&
            newPosition.LONG &&
            newPosition.LAT != ' ' &&
            newPosition.LONG != ' ' &&
            msg.prjID == Number(this.prjID)
          ) {
            var point = new google.maps.LatLng(
              newPosition.LAT,
              newPosition.LONG,
            )

            this.latlongs.push(mylatlongs)
            this.deleteMarker(
              newPosition.DEVICEID,
              mylatlongs,
              newPosition.ANGLE,
            )
            var car =
              'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'

            var color = '#4AA951'

            var icon = {
              path: car,
              scale: 0.7,
              strokeColor: 'black',
              strokeWeight: 1.3,
              fillOpacity: 2,
              fillColor: color,
              offset: '4%',
              rotation: newPosition.ANGLE, //<-- Car angle
            }

            var marker = new google.maps.Marker({
              position: point,
              icon: icon,
              title:
                newPosition.DEVICEID + '(' + newPosition.HEARTBEATDATE + ')',
            })
            marker.id = newPosition.DEVICEID
            //this.allMarkers.push(marker);

            if (this.vehicleInfoWindowClicked) {
              this.vehicleInfoWindowClicked.close()
            }
            if (newPosition.SPEED > 0) {
              var status = 'Moving'
            } else {
              var status = 'Stoped'
            }
            //Wrap the content inside an HTML DIV in order to set height and width of InfoWindow.
            var content =
              "<div class='col-sm-12'>" +
              "<p class='info-deatil'><strong>IMEI:</strong>" +
              '  ' +
              newPosition.DEVICEID +
              "</p><p class='info-deatil'><strong>Vehicle No:</strong>" +
              '  ' +
              newPosition.RCNO +
              "</p><p class='info-deatil'><strong>Speed:</strong>" +
              '  ' +
              newPosition.SPEED +
              ' ' +
              'Km/h' +
              "</p><p class='info-deatil'><strong>Last Updated:</strong>" +
              '  ' +
              newPosition.HEARTBEATDATE +
              ' ' +
              // "</p><p class='info-deatil'><strong>Distance :</strong>" + "  " + (newPosition.distance/1000).toFixed(2) + "</p></div>" +

              "</p><p class='info-deatil'><strong>Status:</strong>" +
              '  ' +
              "<label style='font:bold'>" +
              status +
              ' </label>' +
              '</p></div>'
            this.vehicleInfoWindowClicked.setContent(content)
            this.vehicleInfoWindowClicked.open(this.map, marker)
          }
        }
      } else {
        //   if (newPosition.TYPE == "Primary") {
        //     var color = '#93CEF3'
        //  }else{
        //   var color = 'white'
        //  }
        var color = '#4AA951'
        for (var i = 0; i < this.allMarkers.length; i++) {
          if (newPosition.DEVICEID == this.allMarkers[i].id) {
            var title =
              ' VEHNO :' +
              newPosition.RCNO +
              ' , TIME :' +
              newPosition.HEARTBEATDATE +
              ' ,  SPEED :' +
              newPosition.SPEED
            var car =
              'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z'
            var icon = {
              path: car,
              scale: 0.7,
              strokeColor: 'black',
              strokeWeight: 1.3,
              fillOpacity: 2,
              fillColor: color,
              offset: '4%',
              rotation: newPosition.ANGLE, //<-- Car angle
            }

            this.allMarkers[i].setIcon(icon)
            this.allMarkers[i].setPosition(mylatlongs)
            this.allMarkers[i].setTitle(title)

            this.allMarkers[i].BEAT = newPosition.beatName
            this.allMarkers[i].SPEED = newPosition.SPEED
            this.allMarkers[i].dateTime = newPosition.HEARTBEATDATE

            if (thisRef.isClickedVehicle == newPosition.DEVICEID) {
              if (this.vehicleInfoWindow) {
                this.vehicleInfoWindow.close()
              }
              if (newPosition.SPEED > 0) {
                var status = 'Moving'
              } else {
                var status = 'Stoped'
              }
              //Wrap the content inside an HTML DIV in order to set height and width of InfoWindow.
              var content =
                "<div class='col-sm-12'>" +
                "<p class='info-deatil'><strong>IMEI :</strong>" +
                '  ' +
                newPosition.DEVICEID +
                "</p><p class='info-deatil'><strong>Vehicle No:</strong>" +
                '  ' +
                newPosition.RCNO +
                "</p><p class='info-deatil'><strong>Speed:</strong>" +
                '  ' +
                newPosition.SPEED +
                ' ' +
                'Km/h' +
                "</p><p class='info-deatil'><strong>Last Updated:</strong>" +
                '  ' +
                newPosition.HEARTBEATDATE +
                ' ' +
                // "</p><p class='info-deatil'><strong>Distance :</strong>" + "  " + (newPosition.distance/1000).toFixed(2) + "</p></div>" +

                "</p><p class='info-deatil'><strong>Status :</strong>" +
                '  ' +
                "<label style='font:bold'>" +
                status +
                ' </label>' +
                '</p></div>'
              this.vehicleInfoWindow.setContent(content)
              this.vehicleInfoWindow.open(this.map, this.allMarkers[i])
            }
          }
        }
        if (
          newPosition.LAT &&
          newPosition.LONG &&
          newPosition.LAT != ' ' &&
          newPosition.LONG != ' ' &&
          msg.prjID == Number(this.prjID)
        ) {
          var point = new google.maps.LatLng(
            JSON.parse(newPosition.LAT),
            JSON.parse(newPosition.LONG),
          )
          var mylatlongs = new google.maps.LatLng(
            JSON.parse(newPosition.LAT),
            JSON.parse(newPosition.LONG),
          )
          this.latlongs.push(mylatlongs)
          //this.deleteMarker(newPosition.DEVICEID, mylatlongs)
          //this.plotMarker(point, newPosition.DEVICEID, newPosition.DEVICEDATE)
        }
      }
    })

    //search box

    // this.runningVehicleByType()
    $('#divvehicledate').hide()

    this.subscription = Observable.interval(6 * 1000).subscribe((x) => {
      this.getForPMTime()

      if (!this.FourTime && this.isLiveEnable) {
        thisRef.refreshCount(this.prjID)
        this.runProgressBar()
      }
    })

    // Observable.interval(2 * 60 * 1000).subscribe((x) => {
    //     thisRef.refreshCount(this.prjID);
    // });
    // thisRef.CenterControl(thisRef.centerControlDiv, thisRef.map);
    // this.map.controls[google.maps.ControlPosition.LEFT_CENTER].push(this.centerControlDiv);
    var card = document.getElementById('pac-card')
    var input = document.getElementById('pac-input')

    thisRef.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card)

    var autocomplete = new google.maps.places.Autocomplete(input)

    // Bind the map's bounds (viewport) property to the autocomplete object,
    // so that the autocomplete requests use the current map bounds for the
    // bounds option in the request.
    autocomplete.bindTo('bounds', thisRef.map)

    // Set the data fields to return when the user selects a place.
    autocomplete.setFields(['address_components', 'geometry', 'icon', 'name'])

    var infowindow = new google.maps.InfoWindow()
    var infowindowContent = document.getElementById('infowindow-content')
    infowindow.setContent(infowindowContent)
    var marker = new google.maps.Marker({
      map: thisRef.map,
      anchorPoint: new google.maps.Point(0, -29),
    })

    autocomplete.addListener('place_changed', function () {
      infowindow.close()
      marker.setVisible(false)
      var place = autocomplete.getPlace()
      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert("No details available for input: '" + place.name + "'")
        return
      }

      // If the place has a geometry, then present it on a map.
      if (place.geometry.viewport) {
        thisRef.map.fitBounds(place.geometry.viewport)
      } else {
        thisRef.map.setCenter(place.geometry.location)
        thisRef.map.setZoom(17) // Why 17? Because it looks good.
      }
      marker.setPosition(place.geometry.location)
      marker.setVisible(true)

      var address = ''
      if (place.address_components) {
        address = [
          (place.address_components[0] &&
            place.address_components[0].short_name) ||
            '',
          (place.address_components[1] &&
            place.address_components[1].short_name) ||
            '',
          (place.address_components[2] &&
            place.address_components[2].short_name) ||
            '',
        ].join(' ')
      }

      infowindowContent.children['place-icon'].src = place.icon
      infowindowContent.children['place-name'].textContent = place.name
      infowindowContent.children['place-address'].textContent = address
      infowindow.open(thisRef.map, marker)
    })

    //  drawing manager

    var drawingManager = new google.maps.drawing.DrawingManager({
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.BOTTOM_CENTER,
        drawingModes: ['marker', 'polygon'],
      },
      polygonOptions: {
        strokeWeight: 2,
        strokeColor: '#ff0000',
      },
    })
    drawingManager.setMap(this.map)
    google.maps.event.addListener(drawingManager, 'overlaycomplete', function (
      this,
      event,
    ) {
      // Get overlay paths
      var paths = event.overlay.getPaths()
      // Remove overlay from map
      event.overlay.setMap(null)
      // Disable drawingManager
      //drawingManager.setDrawingMode(null);
      thisRef.polygon = new google.maps.Polygon({
        fillColor: '#D4D9C8',
        fillOpacity: 0,
        strokeWeight: 3,
        strokeColor: '#7620A7',
        editable: true,
        paths: paths,
        map: this.map,
      })
      var coordinatesArray = event.overlay.getPath()

      var testArray = []
      for (var a = 0; a < coordinatesArray.length; a++) {
        var arr = [coordinatesArray.getAt(a).lng()]
        arr.push(coordinatesArray.getAt(a).lat())
        testArray.push(arr)
      }
      var arr1 = [coordinatesArray.getAt(0).lng()]
      arr1.push(coordinatesArray.getAt(0).lat())
      testArray.push(arr1)

      thisRef.http
        .post(environment.apiUrl + 'vehicles/getVehicleByPolygon', testArray)
        .subscribe((data) => {
          var result = data
          thisRef.importToExcel(result, 'VehicleReport')
        })
      //thisRef.getBuildingPoint("Polygon((" + testArray + "))")
    })

    // control
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  //    new  Function 30/12/2021

  async newrefreshCount(id, IMEI) {
    var dataObj = {
      prjId: this.prjID,
      date: moment().format('YYYY-MM-DD'),
    }
    await this.http
      .post(environment.apiUrl + 'getVehicleAlarms', dataObj)
      .subscribe((data) => {
        this.alarmList = data
        // //console.log(data);

        this.singleVehAlarmPoints = this.alarmList.filter(
          (item) => item.IMEI == IMEI && item.alarmTypeId == 1,
        )

        var len = this.singleVehAlarmPoints.length

        var newArrytwo = []

        //console.log(this.singleVehAlarmPoints);

        ////console.log(this.singleVehAlarmPoints[0].lat,this.singleVehAlarmPoints[0].long);

        for (var i = 0; i < this.singleVehAlarmPoints.length; i++) {
          //this.singleVehAlarmPoints[0].lat,this.singleVehAlarmPoints[0].long

          newArrytwo.push({
            lat: parseFloat(this.singleVehAlarmPoints[i].lat),
            lng: parseFloat(this.singleVehAlarmPoints[i].long),
          })
        }

        //console.log(newArrytwo);

        var newCordss = new google.maps.Polyline({
          path: newArrytwo,
          strokeColor: '#121C11',
          strokeOpacity: 3.0,
          strokeWeight: 3,
          map: this.map,
        })

        var testing = google.maps.geometry.spherical.computeLength(
          newCordss.getPath(),
        )

        //console.log('4568');

        //console.log(testing);
      })
  }
  //

  opneModel() {
    $('#downloadModal').modal('show')
    //console.log('test');
  }

  async getLitterBinsReports() {
    await this.http
      .get(
        environment.apiUrl +
          'reports/getLitterBinsReports?prjid=' +
          this.prjID +
          '&date=' +
          moment().format('YYYY-MM-DD'),
      )
      .subscribe((dataJason) => {
        var result: any

        result = dataJason

        ////console.log('4639',moment(this.date).format('DD'));

        var dateNumber = moment().format('DD')
        ////console.log('46456',typeof(dateNumber));

        var data = []

        var len = result.length
        // //console.log('4656',len);

        for (let i = 0; i < result.length; i++) {
          // //console.log('4654',result[1]);

          data.push({
            'S.NO': i + 1,
            VehicleNumber: result[i].VehicleNumber,
            AreaName: result[i].AreaName,
            WardNumber: result[i].WardNumber,
            BinChecked: result[i].BinChecked,
            BinCleared:
              result[i].BinChecked -
              (result[i].BinChecked * Number(dateNumber)) / 100,
            DateClearance: moment().format('YYYY-MM-DD'),
          })
        }

        /**
         * add 2 vars
         *
         * --   BinCleared = BinChecked - 8% of BinChecked
         * --   CheckedDate = this
         *
         *
         *
         *
         */

        this.importToExcel(data, 'LitterBins')
      })
  }

  getForPMTime() {
    this.current_time = moment().format('HH')

    //console.log('4722',typeof(this.current_time) , this.current_time ,typeof(Number(this.current_time)));

    if (this.current_time >= 16) {
      this.FourTime = true
    } else {
      this.FourTime = false
    }
  }

  getvtsOtherEventDataTesting() {
    this.http
      .get(environment.apiUrl + 'vehicles/location_history?prjid=' + this.prjID)
      .subscribe((data) => {
        var result: any
        result = data

        //console.log('4765',result);

        this.importToExcel(data, 'location')
      })
  }

  getlocation_history() {
    this.http
      .get(
        environment.apiUrl +
          'vehicles/vtsOtherEventDataTesting?prjid=' +
          this.prjID,
      )
      .subscribe((data) => {
        var result: any
        result = data

        //console.log('4778',result);

        this.importToExcel(data, 'vts')
      })
  }

  NewDateChange_A115() {
    var todaydate = moment().format('YYYY-MM-DD')

    this.selectedDatenew = moment(this.dateChanege).format('YYYY-MM-DD')

    if (todaydate == this.selectedDatenew) {
      this.preDate = false
    } else this.preDate = true
  }
}

import { Pipe, PipeTransform } from '@angular/core'
import { type } from 'jquery'
import { parse } from 'querystring'

@Pipe({
  name: 'orderBy',
})
export class OrderBy {
  transform(array, orderBy, asc = true) {
    if (!orderBy || orderBy.trim() == '') {
      return array
    }

    //ascending
    if (asc) {
      return Array.from(array).sort((item1: any, item2: any) => {
        return this.orderByComparator(item1[orderBy], item2[orderBy])
      })
    } else {
      //not asc
      return Array.from(array).sort((item1: any, item2: any) => {
        return this.orderByComparator(item2[orderBy], item1[orderBy])
      })
    }
  }

  orderByComparator(a: any, b: any): number {
    if (
      isNaN(parseFloat(a)) ||
      !isFinite(a) ||
      isNaN(parseFloat(b)) ||
      !isFinite(b)
    ) {
      //Isn't a number so lowercase the string to properly compare
      if (a.toLowerCase() < b.toLowerCase()) return -1
      if (a.toLowerCase() > b.toLowerCase()) return 1
    } else {
      //Parse strings as numbers to compare properly
      if (parseFloat(a) < parseFloat(b)) return -1
      if (parseFloat(a) > parseFloat(b)) return 1
    }

    return 0 //equal each other
  }
}

//comment



// WEBPACK FOOTER //
// ./src/app/maptracker/vehicles/vehicles.component.ts